export default {
  'views.bizUser.query.email': 'Email',
  'views.bizUser.query.emailPlaceholder': 'Enter email',
  'views.bizUser.query.nickname': 'Nickname',
  'views.bizUser.query.nicknamePlaceholder': 'Enter nickname',
  'views.bizUser.query.isVip': 'Professional',
  'views.bizUser.query.isVipPlaceholder': 'Select professional or not',
  'views.bizUser.query.paymentMethod': 'Payment method',
  'views.bizUser.query.paymentMethodPlaceholder': 'Select payment method',
  'views.bizUser.query.userStatus': 'User status',
  'views.bizUser.query.userStatusPlaceholder': 'Select user status',
  'views.bizUser.btn.query': 'Search',
  'views.bizUser.btn.reset': 'Reset',
  'views.bizUser.btn.createAccount': 'Create account',
  'views.bizUser.option.notPro': 'Not professional',
  'views.bizUser.option.pro': 'Professional',
  'views.bizUser.option.paymentFull': 'Full payment',
  'views.bizUser.option.paymentFirst': 'Down payment',
  'views.bizUser.option.paymentMonthly': 'Monthly',
  'views.bizUser.column.id': 'ID',
  'views.bizUser.column.email': 'Email',
  'views.bizUser.column.nickname': 'Nickname',
  'views.bizUser.column.isVip': 'Professional',
  'views.bizUser.column.paymentMethod': 'Payment method',
  'views.bizUser.column.firstRate': 'Down payment ratio',
  'views.bizUser.column.userStatus': 'User status',
  'views.bizUser.column.createTime': 'Registered at',
  'views.bizUser.column.operation': 'Actions',
  'views.bizUser.cell.dash': '-',
  'views.bizUser.action.resetPassword': 'Reset password',
  'views.bizUser.action.editVipPayment': 'Edit professional / payment',
  'views.bizUser.pagination.total': 'Total {total}',
  'views.bizUser.msg.operationSuccess': 'Success',
  'views.bizUser.msg.statusFail': 'Failed to update status',
  'views.bizUser.confirm.deleteTitle': 'Delete selected records?',
  'views.bizUser.confirm.deleteContent': 'Selected IDs: {ids}',
  'views.bizUser.msg.deleteSuccess': 'Deleted',
  'views.bizUser.confirm.exportTitle': 'Export?',
  'views.bizUser.confirm.exportContent': 'This will export all data matching current filters, not only selected rows.',
  'views.bizUser.export.filename': 'users_{time}.xlsx',

  'views.bizUser.resetPwd.title': 'Reset password',
  'views.bizUser.resetPwd.newPassword': 'New password',
  'views.bizUser.resetPwd.newPasswordPlaceholder': 'Enter new password',
  'views.bizUser.resetPwd.confirmPassword': 'Confirm password',
  'views.bizUser.resetPwd.confirmPasswordPlaceholder': 'Confirm new password',
  'views.bizUser.resetPwd.err.newPwdRequired': 'Please enter new password',
  'views.bizUser.resetPwd.err.newPwdPattern': '6–12 characters: letters and numbers',
  'views.bizUser.resetPwd.err.confirmRequired': 'Please confirm new password',
  'views.bizUser.resetPwd.err.confirmMismatch': 'Passwords do not match',
  'views.bizUser.resetPwd.msg.success': 'Password reset',

  'views.bizUser.vipPayment.title': 'Edit professional / payment',
  'views.bizUser.vipPayment.isVip': 'Professional',
  'views.bizUser.vipPayment.isVipPlaceholder': 'Select professional or not',
  'views.bizUser.vipPayment.paymentMethod': 'Payment method',
  'views.bizUser.vipPayment.paymentMethodPlaceholder': 'Select payment method',
  'views.bizUser.vipPayment.firstRate': 'Down payment ratio',
  'views.bizUser.vipPayment.firstRatePlaceholder': 'Enter ratio (0,1]',
  'views.bizUser.vipPayment.err.firstRateRequired': 'Enter down payment ratio',
  'views.bizUser.vipPayment.err.firstRateNumber': 'Ratio must be a number',
  'views.bizUser.vipPayment.err.firstRateGt0': 'Ratio must be greater than 0',
  'views.bizUser.vipPayment.err.firstRateLte1': 'Ratio cannot exceed 1',
  'views.bizUser.vipPayment.err.firstRateDecimal': 'At most 2 decimal places',
  'views.bizUser.vipPayment.rule.selectIsVip': 'Select professional or not',
  'views.bizUser.vipPayment.rule.selectPayment': 'Select payment method',
  'views.bizUser.vipPayment.msg.success': 'Saved',

  'views.bizUser.createAccount.title': 'Create account',
  'views.bizUser.createAccount.email': 'Email',
  'views.bizUser.createAccount.emailPlaceholder': 'Login email',
  'views.bizUser.createAccount.nickname': 'Nickname',
  'views.bizUser.createAccount.nicknamePlaceholder': 'Enter nickname',
  'views.bizUser.createAccount.mobile': 'Mobile',
  'views.bizUser.createAccount.mobilePlaceholder': 'Optional, for mobile login',
  'views.bizUser.createAccount.password': 'Password',
  'views.bizUser.createAccount.passwordPlaceholder': '6–12 letters and digits',
  'views.bizUser.createAccount.confirmPassword': 'Confirm password',
  'views.bizUser.createAccount.confirmPasswordPlaceholder': 'Re-enter password',
  'views.bizUser.createAccount.status': 'User status',
  'views.bizUser.createAccount.save': 'Save',
  'views.bizUser.createAccount.cancel': 'Cancel',
  'views.bizUser.createAccount.rule.emailRequired': 'Email is required',
  'views.bizUser.createAccount.rule.emailFormat': 'Enter a valid email',
  'views.bizUser.createAccount.rule.nicknameRequired': 'Nickname is required',
  'views.bizUser.createAccount.rule.statusRequired': 'Select user status',
  'views.bizUser.createAccount.msg.success': 'Account created',
  'views.bizUser.createAccount.msg.fail': 'Failed to create account',

  'views.userCategory.query.name': 'Name',
  'views.userCategory.query.namePlaceholder': 'Enter name',
  'views.userCategory.btn.query': 'Search',
  'views.userCategory.btn.reset': 'Reset',
  'views.userCategory.btn.add': 'Add',
  'views.userCategory.btn.edit': 'Edit',
  'views.userCategory.btn.delete': 'Delete',
  'views.userCategory.column.id': 'ID',
  'views.userCategory.column.name': 'Name',
  'views.userCategory.column.nameEn': 'Name (EN)',
  'views.userCategory.column.sort': 'Sort',
  'views.userCategory.column.status': 'Status',
  'views.userCategory.column.createTime': 'Created at',
  'views.userCategory.column.operation': 'Actions',
  'views.userCategory.pagination.total': 'Total {total}',
  'views.userCategory.confirm.deleteTitle': 'Delete selected records?',
  'views.userCategory.confirm.deleteContent': 'Selected IDs: {ids}',
  'views.userCategory.msg.deleteSuccess': 'Deleted',
  'views.userCategory.confirm.exportTitle': 'Export?',
  'views.userCategory.confirm.exportContent': 'This will export all data matching current filters, not only selected rows.',
  'views.userCategory.export.filename': 'category_{time}.xlsx',
  'views.userCategory.msg.statusOk': 'Status updated',
  'views.userCategory.msg.statusFail': 'Status update failed',
  'views.userCategory.msg.sortOk': 'Sort updated',
  'views.userCategory.msg.sortFail': 'Sort update failed',

  'views.userCategory.form.name': 'Name',
  'views.userCategory.form.namePlaceholder': 'Enter name',
  'views.userCategory.form.nameEn': 'Name (EN)',
  'views.userCategory.form.nameEnPlaceholder': 'Enter English name',
  'views.userCategory.form.save': 'Save',
  'views.userCategory.form.cancel': 'Cancel',
  'views.userCategory.rule.nameRequired': 'Name is required',
  'views.userCategory.title.add': 'Add',
  'views.userCategory.title.edit': 'Edit',
  'views.userCategory.msg.updateOk': 'Updated',
  'views.userCategory.msg.updateFail': 'Update failed',
  'views.userCategory.msg.addOk': 'Created',
  'views.userCategory.msg.addFail': 'Create failed',

  'views.appConfig.query.configGroup': 'Group',
  'views.appConfig.query.configGroupPlaceholder': 'Enter group',
  'views.appConfig.query.configName': 'Variable key',
  'views.appConfig.query.configNamePlaceholder': 'Enter variable key',
  'views.appConfig.query.title': 'Title',
  'views.appConfig.query.titlePlaceholder': 'Enter title',
  'views.appConfig.btn.query': 'Search',
  'views.appConfig.btn.reset': 'Reset',
  'views.appConfig.btn.add': 'Add',
  'views.appConfig.btn.edit': 'Edit',
  'views.appConfig.btn.delete': 'Delete',
  'views.appConfig.column.id': 'ID',
  'views.appConfig.column.configGroup': 'Group',
  'views.appConfig.column.configName': 'Variable key',
  'views.appConfig.column.varTitle': 'Title',
  'views.appConfig.column.description': 'Description',
  'views.appConfig.column.configValue': 'Value',
  'views.appConfig.column.configValueEn': 'Value (EN)',
  'views.appConfig.column.operation': 'Actions',
  'views.appConfig.pagination.total': 'Total {total}',
  'views.appConfig.confirm.deleteTitle': 'Delete selected records?',
  'views.appConfig.confirm.deleteContent': 'Selected IDs: {ids}',
  'views.appConfig.msg.deleteSuccess': 'Deleted',
  'views.appConfig.confirm.exportTitle': 'Export?',
  'views.appConfig.confirm.exportContent': 'This will export all data matching current filters, not only selected rows.',
  'views.appConfig.export.filename': 'app_config_{time}.xlsx',

  'views.appConfig.form.group': 'Group',
  'views.appConfig.form.groupPlaceholder': 'Enter group',
  'views.appConfig.form.varName': 'Variable key',
  'views.appConfig.form.varNamePlaceholder': 'Enter variable key',
  'views.appConfig.form.varTitle': 'Title',
  'views.appConfig.form.varTitlePlaceholder': 'Enter title',
  'views.appConfig.form.paramType': 'Type',
  'views.appConfig.form.value': 'Value',
  'views.appConfig.form.valuePlaceholder': 'Enter value',
  'views.appConfig.form.valueNumberPlaceholder': 'Enter number',
  'views.appConfig.form.valueEn': 'Value (EN)',
  'views.appConfig.form.valueEnPlaceholder': 'Enter English value',
  'views.appConfig.form.description': 'Description',
  'views.appConfig.form.descriptionPlaceholder': 'Enter description',
  'views.appConfig.form.save': 'Save',
  'views.appConfig.form.cancel': 'Cancel',
  'views.appConfig.type.text': 'Text',
  'views.appConfig.type.richText': 'Rich text',
  'views.appConfig.type.number': 'Number',
  'views.appConfig.type.image': 'Image',
  'views.appConfig.rule.groupRequired': 'Group is required',
  'views.appConfig.rule.nameRequired': 'Variable key is required',
  'views.appConfig.rule.titleRequired': 'Title is required',
  'views.appConfig.rule.valueRequired': 'Value is required',
  'views.appConfig.rule.typeRequired': 'Type is required',
  'views.appConfig.msg.imageOnly': 'Please upload an image',
  'views.appConfig.upload.uploading': 'Uploading',
  'views.appConfig.upload.action': 'Upload',
  'views.appConfig.title.add': 'Add',
  'views.appConfig.title.edit': 'Edit',
  'views.appConfig.msg.addOk': 'Created',
  'views.appConfig.msg.updateOk': 'Updated',

  'views.appFeedback.query.nickname': 'Nickname',
  'views.appFeedback.query.nicknamePlaceholder': 'Enter nickname',
  'views.appFeedback.query.contact': 'Contact',
  'views.appFeedback.query.contactPlaceholder': 'Enter contact',
  'views.appFeedback.query.processStatus': 'Reply status',
  'views.appFeedback.query.processStatusPlaceholder': 'Select reply status',
  'views.appFeedback.processStatus.pending': 'Pending reply',
  'views.appFeedback.processStatus.done': 'Replied',
  'views.appFeedback.processStatus.skipped': 'No reply',
  'views.appFeedback.btn.query': 'Search',
  'views.appFeedback.btn.reset': 'Reset',
  'views.appFeedback.btn.delete': 'Delete',
  'views.appFeedback.btn.handle': 'Reply',
  'views.appFeedback.title.replyAudit': 'Reply',
  'views.appFeedback.title.add': 'Add',
  'views.appFeedback.img.notUploaded': 'None',
  'views.appFeedback.img.previewFallback': 'No image',
  'views.appFeedback.column.seq': '#',
  'views.appFeedback.column.id': 'ID',
  'views.appFeedback.column.nickname': 'Nickname',
  'views.appFeedback.column.feedbackType': 'Type',
  'views.appFeedback.column.content': 'Description',
  'views.appFeedback.column.imgUrls': 'Images',
  'views.appFeedback.column.contact': 'Contact',
  'views.appFeedback.column.processStatus': 'Reply status',
  'views.appFeedback.column.processResult': 'Reply content',
  'views.appFeedback.form.processResultPlaceholder': 'Enter reply content',
  'views.appFeedback.column.processResultEn': 'Reply content (EN)',
  'views.appFeedback.form.processResultEnPlaceholder': 'Enter reply content (English)',
  'views.appFeedback.form.save': 'Save',
  'views.appFeedback.form.cancel': 'Cancel',
  'views.appFeedback.column.createTime': 'Created at',
  'views.appFeedback.column.operation': 'Actions',
  'views.appFeedback.pagination.total': 'Total {total}',
  'views.appFeedback.confirm.deleteTitle': 'Delete selected records?',
  'views.appFeedback.confirm.deleteContent': 'Selected IDs: {ids}',
  'views.appFeedback.msg.deleteSuccess': 'Deleted',
  'views.appFeedback.msg.updateSuccess': 'Updated',
  'views.appFeedback.msg.addSuccess': 'Added',

  'views.homeNotice.query.title': 'Title',
  'views.homeNotice.query.titlePlaceholder': 'Enter title',
  'views.homeNotice.query.sort': 'Sort',
  'views.homeNotice.query.sortPlaceholder': 'Enter sort',
  'views.homeNotice.btn.query': 'Search',
  'views.homeNotice.btn.reset': 'Reset',
  'views.homeNotice.btn.add': 'Add',
  'views.homeNotice.btn.edit': 'Edit',
  'views.homeNotice.btn.delete': 'Delete',
  'views.homeNotice.column.id': 'ID',
  'views.homeNotice.column.title': 'Title',
  'views.homeNotice.column.content': 'Content',
  'views.homeNotice.column.contentEn': 'Content (EN)',
  'views.homeNotice.column.sort': 'Sort',
  'views.homeNotice.column.status': 'Status',
  'views.homeNotice.column.createTime': 'Created at',
  'views.homeNotice.column.operation': 'Actions',
  'views.homeNotice.pagination.total': 'Total {total}',
  'views.homeNotice.confirm.deleteTitle': 'Delete selected records?',
  'views.homeNotice.confirm.deleteContent': 'Selected IDs: {ids}',
  'views.homeNotice.msg.deleteSuccess': 'Deleted',
  'views.homeNotice.confirm.exportTitle': 'Export?',
  'views.homeNotice.confirm.exportContent': 'This will export all data matching current filters, not only selected rows.',
  'views.homeNotice.export.filename': 'home_notice_{time}.xlsx',
  'views.homeNotice.msg.statusUpdateSuccess': 'Status updated',
  'views.homeNotice.msg.statusUpdateFail': 'Failed to update status',
  'views.homeNotice.msg.sortUpdateSuccess': 'Sort updated',
  'views.homeNotice.msg.sortUpdateFail': 'Failed to update sort',

  'views.homeNotice.form.title': 'Title',
  'views.homeNotice.form.titlePlaceholder': 'Enter title',
  'views.homeNotice.form.content': 'Content',
  'views.homeNotice.form.contentEn': 'Content (EN)',
  'views.homeNotice.form.save': 'Save',
  'views.homeNotice.form.cancel': 'Cancel',
  'views.homeNotice.title.add': 'Add',
  'views.homeNotice.title.edit': 'Edit',
  'views.homeNotice.rule.titleRequired': 'Title is required',
  'views.homeNotice.rule.contentRequired': 'Content is required',
  'views.homeNotice.msg.addOk': 'Created',
  'views.homeNotice.msg.updateOk': 'Updated',
  'views.homeNotice.msg.addFail': 'Create failed',
  'views.homeNotice.msg.updateFail': 'Update failed',

  'views.banner.query.type': 'Placement',
  'views.banner.query.typePlaceholder': 'Select placement',
  'views.banner.query.title': 'Title',
  'views.banner.query.titlePlaceholder': 'Enter title',
  'views.banner.query.link': 'Link ID',
  'views.banner.query.linkPlaceholder': 'Enter link ID',
  'views.banner.query.linkUrl': 'External URL',
  'views.banner.query.linkUrlPlaceholder': 'Enter external URL',
  'views.banner.query.sort': 'Sort',
  'views.banner.query.sortPlaceholder': 'Enter sort',
  'views.banner.btn.query': 'Search',
  'views.banner.btn.reset': 'Reset',
  'views.banner.btn.add': 'Add',
  'views.banner.btn.edit': 'Edit',
  'views.banner.btn.delete': 'Delete',
  'views.banner.type.home': 'Home',
  'views.banner.type.company': 'Company profile',
  'views.banner.column.id': 'ID',
  'views.banner.column.type': 'Placement',
  'views.banner.column.title': 'Title',
  'views.banner.column.titleEn': 'Title (EN)',
  'views.banner.column.content': 'Content',
  'views.banner.column.contentEn': 'Content (EN)',
  'views.banner.column.imgUrl': 'Image',
  'views.banner.column.status': 'Status',
  'views.banner.column.sort': 'Sort',
  'views.banner.column.createTime': 'Created at',
  'views.banner.column.operation': 'Actions',
  'views.banner.pagination.total': 'Total {total}',
  'views.banner.confirm.deleteTitle': 'Delete selected records?',
  'views.banner.confirm.deleteContent': 'Selected IDs: {ids}',
  'views.banner.msg.deleteSuccess': 'Deleted',
  'views.banner.confirm.exportTitle': 'Export?',
  'views.banner.confirm.exportContent': 'This will export all data matching current filters, not only selected rows.',
  'views.banner.export.filename': 'banner_{time}.xlsx',
  'views.banner.msg.inlineSaveOk': 'Saved',

  'views.banner.form.type': 'Placement',
  'views.banner.form.typePlaceholder': 'Select placement',
  'views.banner.form.title': 'Title',
  'views.banner.form.titlePlaceholder': 'Enter title',
  'views.banner.form.titleEn': 'Title (EN)',
  'views.banner.form.titleEnPlaceholder': 'Enter English title',
  'views.banner.form.remark': 'Summary',
  'views.banner.form.remarkPlaceholder': 'Enter summary',
  'views.banner.form.remarkEn': 'Summary (EN)',
  'views.banner.form.remarkEnPlaceholder': 'Enter English summary',
  'views.banner.form.content': 'Content',
  'views.banner.form.contentEn': 'Content (EN)',
  'views.banner.form.linkType': 'Link type',
  'views.banner.form.linkTypePlaceholder': 'Select link type',
  'views.banner.form.linkTypeNone': 'None',
  'views.banner.form.linkTypeOuter': 'External link',
  'views.banner.form.linkUrl': 'External URL',
  'views.banner.form.linkUrlPlaceholder': 'Enter external URL',
  'views.banner.form.image': 'Image',
  'views.banner.form.save': 'Save',
  'views.banner.form.cancel': 'Cancel',
  'views.banner.title.add': 'Add',
  'views.banner.title.edit': 'Edit',
  'views.banner.rule.imgRequired': 'Image is required',
  'views.banner.rule.sortRequired': 'Sort is required',
  'views.banner.msg.addOk': 'Created',
  'views.banner.msg.updateOk': 'Updated',
  'views.banner.msg.companyTypeExists': 'A company profile banner already exists. You cannot add another.',

  'views.systemNotice.query.type': 'Notice type',
  'views.systemNotice.query.typePlaceholder': 'Select type',
  'views.systemNotice.query.title': 'Notice title',
  'views.systemNotice.query.titlePlaceholder': 'Enter title',
  'views.systemNotice.btn.query': 'Search',
  'views.systemNotice.btn.reset': 'Reset',
  'views.systemNotice.btn.add': 'Add',
  'views.systemNotice.btn.edit': 'Edit',
  'views.systemNotice.btn.delete': 'Delete',
  'views.systemNotice.column.id': 'ID',
  'views.systemNotice.column.type': 'Type',
  'views.systemNotice.type.notice': 'Notice',
  'views.systemNotice.type.versionUpdate': 'Version update',
  'views.systemNotice.column.title': 'Title',
  'views.systemNotice.column.titleEn': 'Title (EN)',
  'views.systemNotice.column.image': 'Image',
  'views.systemNotice.column.content': 'Content',
  'views.systemNotice.column.contentEn': 'Content (EN)',
  'views.systemNotice.column.status': 'Status',
  'views.systemNotice.column.createTime': 'Created at',
  'views.systemNotice.column.operation': 'Actions',
  'views.systemNotice.pagination.total': 'Total {total}',
  'views.systemNotice.confirm.deleteTitle': 'Delete selected records?',
  'views.systemNotice.confirm.deleteContent': 'Selected IDs: {ids}',
  'views.systemNotice.msg.deleteSuccess': 'Deleted',

  'views.systemNotice.form.noticeType': 'Notice type',
  'views.systemNotice.form.noticeTypePlaceholder': 'Select type',
  'views.systemNotice.form.title': 'Title',
  'views.systemNotice.form.titlePlaceholder': 'Enter title',
  'views.systemNotice.form.titleEn': 'Title (EN)',
  'views.systemNotice.form.titleEnPlaceholder': 'Enter English title',
  'views.systemNotice.form.image': 'Image',
  'views.systemNotice.form.content': 'Content',
  'views.systemNotice.form.contentEn': 'Content (EN)',
  'views.systemNotice.form.save': 'Save',
  'views.systemNotice.form.cancel': 'Cancel',
  'views.systemNotice.title.add': 'Add notice',
  'views.systemNotice.title.edit': 'Edit notice',
  'views.systemNotice.rule.typeRequired': 'Type is required',
  'views.systemNotice.rule.titleRequired': 'Title is required',
  'views.systemNotice.rule.contentRequired': 'Content is required',
  'views.systemNotice.msg.addOk': 'Created',
  'views.systemNotice.msg.updateOk': 'Updated',

  'component.tableSetting.sizeDefault': 'Default',
  'component.tableSetting.sizeMiddle': 'Middle',
  'component.tableSetting.sizeSmall': 'Compact',
  'component.tableSetting.columnShowSort': 'Columns & order',
  'component.tableSetting.columnDragHint': 'Drag a column name to reorder',

  'views.goodsOrder.action.paymentRecord': 'Payments',
  'views.goodsOrder.action.detail': 'Detail',
  'views.goodsOrder.drawer.paymentTitleWithOrder': 'Payment records (Order: {orderNo})',
  'views.goodsOrder.drawer.detailTitleWithOrder': 'Order detail ({orderNo})',
  'views.goodsOrder.detail.userId': 'User ID',
  'views.goodsOrder.detail.goodsId': 'Goods ID',
  'views.goodsOrder.detail.firstStatus': 'First payment status',
  'views.goodsOrder.detail.finalStatus': 'Final payment status',
  'views.goodsOrder.detail.productionStatus': 'Production status',
  'views.goodsOrder.detail.typesettingType': 'Typesetting',
  'views.goodsOrder.detail.rowStatus': 'Enabled',
  'views.goodsOrder.detail.remark': 'Remark',
  'views.goodsOrder.detail.priceTierTitle': 'Price tier table',
  'views.goodsOrder.detail.priceTierTotalQty': 'Total quantity',
  'views.goodsOrder.detail.priceTierPrice': 'Price',
  'views.goodsOrder.detail.priceTierMoneyFmt': '¥{amount}',
  'views.goodsOrder.detail.empty': 'No data',
  'views.goodsOrder.detail.productionProgress': 'Production progress',
  'views.goodsOrder.detail.deliveryInfo': 'Shipping / delivery',
  'views.goodsOrder.detail.copy': 'Copy',
  'views.goodsOrder.detail.copyOk': 'Copied to clipboard',
  'views.goodsOrder.detail.copyFail': 'Copy failed',
  'views.goodsOrder.detail.copyEmpty': 'Nothing to copy',
  'views.goodsOrder.detail.shippingAddress': 'Shipping address',
  'views.goodsOrder.detail.receiverName': 'Recipient',
  'views.goodsOrder.detail.receiverPhone': 'Phone',
  'views.goodsOrder.detail.addressLabel': 'Address label',
  'views.goodsOrder.detail.detailedAddress': 'Full address',
  'views.goodsOrder.detail.productDetail': 'Product details',
  'views.goodsOrder.detail.quoteDetail': 'Quote breakdown',
  'views.goodsOrder.detail.styleCount': 'Style count',
  'views.goodsOrder.detail.exchangeRateLabel': 'Exchange rate',
  'views.goodsOrder.detail.weightLabel': 'Weight',
  'views.goodsOrder.detail.shippingMethodLabel': 'Shipping method',
  'views.goodsOrder.detail.shippingFee': 'Shipping fee',
  'views.goodsOrder.detail.priceInfo': 'Pricing',
  'views.goodsOrder.detail.paymentMethod': 'Payment method',
  'views.goodsOrder.detail.orderAmount': 'Order amount',
  'views.goodsOrder.detail.payModeFull': 'Full payment',
  'views.goodsOrder.detail.payModeFirstFinal': 'First + final',
  'views.goodsOrder.detail.payModeMonthly': 'Monthly',
  'views.goodsOrder.subPayment.pending': 'Pending',
  'views.goodsOrder.subPayment.confirmed': 'Confirmed',
  'views.goodsOrder.subPayment.rejected': 'Rejected',
  'views.goodsOrder.typesetting.normal': 'Normal',
  'views.goodsOrder.typesetting.doubleFeed': 'Double feed',
  'views.goodsOrder.bool.yes': 'Yes',
  'views.goodsOrder.bool.no': 'No',
  'views.goodsOrder.msg.loadDetailFail': 'Failed to load order detail',
  'views.goodsOrder.action.query': 'Search',
  'views.goodsOrder.action.reset': 'Reset',
  'views.goodsOrder.action.delete': 'Delete',
  'views.goodsOrder.action.markDraftReceived': 'Draft received',
  'views.goodsOrder.confirm.markDraftReceivedTitle': 'Mark order as draft received?',
  'views.goodsOrder.confirm.markDraftReceivedContent': 'Order No.: {orderNo}. Status will change from Awaiting draft to Draft received.',
  'views.goodsOrder.msg.markDraftReceivedOk': 'Marked as draft received',
  'views.goodsOrder.action.editSubmissionEmail': 'Submission email',
  'views.goodsOrder.modal.editSubmissionEmailTitle': 'Edit submission email',
  'views.goodsOrder.modal.submissionEmailLabel': 'Submission email',
  'views.goodsOrder.modal.submissionEmailPlaceholder': 'Enter email, or leave empty to clear',
  'views.goodsOrder.msg.submissionEmailOk': 'Submission email updated',
  'views.goodsOrder.msg.submissionEmailInvalid': 'Please enter a valid email address',
  'views.goodsOrder.action.markProducing': 'Set to in production',
  'views.goodsOrder.confirm.markProducingTitle': 'Set order to in production?',
  'views.goodsOrder.confirm.markProducingContent': 'Order No.: {orderNo}. Order status will change from Draft received to In production, and production stage will be set to Typesetting (1).',
  'views.goodsOrder.msg.markProducingOk': 'Set to in production',
  'views.goodsOrder.action.editProductionStatus': 'Edit production status',
  'views.goodsOrder.modal.editProductionStatusTitle': 'Edit production status',
  'views.goodsOrder.modal.productionStatusPlaceholder': 'Select production stage',
  'views.goodsOrder.msg.updateProductionStatusOk': 'Production status updated',
  'views.goodsOrder.action.submitOrderBoxes': 'Submit boxes & await ship',
  'views.goodsOrder.modal.submitOrderBoxesTitle': 'Enter box specs and move to awaiting shipment',
  'views.goodsOrder.msg.submitOrderBoxesOk': 'Box specs saved; order is now awaiting shipment',
  'views.goodsOrder.action.markShippedFromAwaitShip': 'Mark shipped',
  'views.goodsOrder.action.markAwaitFinalPaymentFromAwaitShip': 'Await final payment',
  'views.goodsOrder.confirm.markShippedFromAwaitShipTitle': 'Mark order as shipped?',
  'views.goodsOrder.confirm.markShippedFromAwaitShipContent': 'Order No.: {orderNo}. Status will change from Awaiting shipment to Shipped.',
  'views.goodsOrder.msg.markShippedFromAwaitShipOk': 'Marked as shipped',
  'views.goodsOrder.modal.markShippedTitle': 'Mark as shipped',
  'views.goodsOrder.modal.markShippedDeliveryNumberPlaceholder': 'Please enter',
  'views.goodsOrder.msg.markShippedDeliveryNumberRequired': 'Please enter delivery / tracking number',
  'views.goodsOrder.msg.markShippedDeliveryTimeRequired': 'Please select ship time',
  'views.goodsOrder.confirm.markAwaitFinalPaymentFromAwaitShipTitle': 'Move to awaiting final payment?',
  'views.goodsOrder.confirm.markAwaitFinalPaymentFromAwaitShipContent': 'Order No.: {orderNo}. Status will change from Awaiting shipment to Awaiting final payment.',
  'views.goodsOrder.msg.markAwaitFinalPaymentFromAwaitShipOk': 'Moved to awaiting final payment',
  'views.goodsOrder.action.markCompletedFromShipped': 'Mark completed',
  'views.goodsOrder.confirm.markCompletedFromShippedTitle': 'Mark order as completed?',
  'views.goodsOrder.confirm.markCompletedFromShippedContent': 'Order No.: {orderNo}. Status will change from Shipped to Completed.',
  'views.goodsOrder.msg.markCompletedFromShippedOk': 'Marked as completed',
  'views.goodsOrder.orderBox.boxLength': 'Length',
  'views.goodsOrder.orderBox.boxWidth': 'Width',
  'views.goodsOrder.orderBox.boxHeight': 'Height',
  'views.goodsOrder.orderBox.boxNum': 'Qty',
  'views.goodsOrder.orderBox.remark': 'Remark',
  'views.goodsOrder.orderBox.addRow': 'Add row',
  'views.goodsOrder.orderBox.removeRow': 'Remove',
  'views.goodsOrder.orderBox.validateRows': 'Fill length, width, height and quantity (integer ≥ 1) for each row',
  'views.goodsOrder.orderBox.keepOneRow': 'Keep at least one row',
  'views.goodsOrder.orderBox.noShippingAddress': 'No shipping address on file',
  'views.goodsOrder.orderBox.deliveryNumber': 'Delivery / tracking No.',
  'views.goodsOrder.orderBox.deliveryNumberPlaceholder': 'Please enter',
  'views.goodsOrder.orderBox.deliveryTime': 'Ship time',
  'views.goodsOrder.orderBox.deliveryTimePlaceholder': 'Select ship time',
  'views.goodsOrder.orderBox.deliveryTimeRequired': 'Please select ship time on every row',
  'views.goodsOrder.productionStage.1': 'Typesetting',
  'views.goodsOrder.productionStage.2': 'Printing',
  'views.goodsOrder.productionStage.3': 'Laminating',
  'views.goodsOrder.productionStage.4': 'Curing',
  'views.goodsOrder.productionStage.5': 'Slitting',
  'views.goodsOrder.productionStage.6': 'Bag making',
  'views.goodsOrder.productionStage.7': 'Inspection',
  'views.goodsOrder.productionStage.8': 'Warehousing',
  'views.goodsOrder.search.goodsName': 'Product name',
  'views.goodsOrder.search.goodsNamePlaceholder': 'Enter product name',
  'views.goodsOrder.search.orderType': 'Order type',
  'views.goodsOrder.search.orderTypePlaceholder': 'Select order type',
  'views.goodsOrder.search.orderStatus': 'Order status',
  'views.goodsOrder.search.orderStatusPlaceholder': 'Select order status',
  'views.goodsOrder.search.orderNo': 'Order No.',
  'views.goodsOrder.search.orderNoPlaceholder': 'Enter order number',
  'views.goodsOrder.search.email': 'User email',
  'views.goodsOrder.search.emailPlaceholder': 'Enter user email',
  'views.goodsOrder.search.nickname': 'User nickname',
  'views.goodsOrder.search.nicknamePlaceholder': 'Enter nickname',
  'views.goodsOrder.search.createTime': 'Created time',
  'views.goodsOrder.search.createTimeStart': 'Start',
  'views.goodsOrder.search.createTimeEnd': 'End',
  'views.goodsOrder.search.width': 'Width',
  'views.goodsOrder.search.widthPlaceholder': 'Enter width',
  'views.goodsOrder.search.height': 'Height',
  'views.goodsOrder.search.heightPlaceholder': 'Enter height',
  'views.goodsOrder.search.bottom': 'Bottom',
  'views.goodsOrder.search.bottomPlaceholder': 'Enter bottom',
  'views.goodsOrder.search.weight': 'Weight',
  'views.goodsOrder.search.weightPlaceholder': 'Enter weight',
  'views.goodsOrder.search.exchangeRate': 'Exchange rate',
  'views.goodsOrder.search.exchangeRatePlaceholder': 'Enter exchange rate',
  'views.goodsOrder.search.shippingMethod': 'Shipping method',
  'views.goodsOrder.search.shippingMethodPlaceholder': 'Enter shipping method',
  'views.goodsOrder.search.stylesNum': 'Style count',
  'views.goodsOrder.search.stylesNumPlaceholder': 'Enter style count',
  'views.goodsOrder.search.totalNum': 'Total quantity',
  'views.goodsOrder.search.totalNumPlaceholder': 'Enter total quantity',
  'views.goodsOrder.search.payMoney': 'Payable amount',
  'views.goodsOrder.search.payMoneyPlaceholder': 'Enter payable amount',
  'views.goodsOrder.search.firstMoney': 'First payment',
  'views.goodsOrder.search.firstMoneyPlaceholder': 'Enter first payment',
  'views.goodsOrder.search.finalMoney': 'Final payment',
  'views.goodsOrder.search.finalMoneyPlaceholder': 'Enter final payment',
  'views.goodsOrder.search.paidMoney': 'Paid amount',
  'views.goodsOrder.search.paidMoneyPlaceholder': 'Enter paid amount',
  'views.goodsOrder.search.shippingMoney': 'Shipping fee',
  'views.goodsOrder.search.shippingMoneyPlaceholder': 'Enter shipping fee',
  'views.goodsOrder.search.calculationFormula': 'Calculation formula',
  'views.goodsOrder.search.calculationFormulaPlaceholder': 'Enter formula',
  'views.goodsOrder.search.goodMoney': 'Actual amount',
  'views.goodsOrder.search.goodMoneyPlaceholder': 'Enter actual amount',
  'views.goodsOrder.search.printingMeters': 'Print meters',
  'views.goodsOrder.search.printingMetersPlaceholder': 'Enter print meters',
  'views.goodsOrder.search.sort': 'Sort',
  'views.goodsOrder.search.sortPlaceholder': 'Enter sort value',
  'views.goodsOrder.column.id': 'ID',
  'views.goodsOrder.column.email': 'User email',
  'views.goodsOrder.column.nickname': 'Nickname',
  'views.goodsOrder.column.orderType': 'Order type',
  'views.goodsOrder.column.goodsName': 'Product name',
  'views.goodsOrder.column.orderStatus': 'Order status',
  'views.goodsOrder.column.productionStatus': 'Production status',
  'views.goodsOrder.column.orderNo': 'Order No.',
  'views.goodsOrder.column.height': 'Height',
  'views.goodsOrder.column.width': 'Width',
  'views.goodsOrder.column.bottom': 'Bottom',
  'views.goodsOrder.column.thickness': 'Thickness',
  'views.goodsOrder.column.stylesNum': 'Style count',
  'views.goodsOrder.column.totalNum': 'Total qty',
  'views.goodsOrder.column.payMoney': 'Quote',
  'views.goodsOrder.column.createTime': 'Created at',
  'views.goodsOrder.column.operation': 'Actions',
  'views.goodsOrder.orderType.full': 'Full payment order',
  'views.goodsOrder.orderType.first': 'First payment order',
  'views.goodsOrder.orderType.monthly': 'Monthly settlement',
  'views.goodsOrder.orderStatus.pending': 'Pending order',
  'views.goodsOrder.orderStatus.awaitPay': 'Ordered, awaiting payment',
  'views.goodsOrder.orderStatus.paidAwaitAudit': 'Paid, awaiting audit',
  'views.goodsOrder.orderStatus.factoryRejected': 'Payment rejected by factory',
  'views.goodsOrder.orderStatus.awaitDraft': 'Awaiting draft',
  'views.goodsOrder.orderStatus.draftReceived': 'Draft received',
  'views.goodsOrder.orderStatus.producing': 'In production',
  'views.goodsOrder.orderStatus.awaitShip': 'Awaiting shipment',
  'views.goodsOrder.orderStatus.awaitFinalPayment': 'Awaiting final payment',
  'views.goodsOrder.orderStatus.shipped': 'Shipped',
  'views.goodsOrder.orderStatus.completed': 'Completed',
  'views.goodsOrder.orderStatus.cancelled': 'Cancelled',
  'views.goodsOrder.pagination.total': 'Total {total} items',
  'views.goodsOrder.confirm.deleteTitle': 'Delete selected records?',
  'views.goodsOrder.confirm.deleteContent': 'Selected IDs: {ids}',
  'views.goodsOrder.msg.deleteOk': 'Deleted',
  'views.goodsOrder.confirm.exportTitle': 'Export data?',
  'views.goodsOrder.confirm.exportContent': 'Exports all data matching current filters, not only selected rows.',
  'views.goodsOrder.export.filename': 'orders_{time}.xlsx',
  'views.goodsOrder.msg.statusOk': 'Status updated',
  'views.goodsOrder.msg.statusFail': 'Status update failed',
  'views.goodsOrder.msg.sortOk': 'Sort updated',
  'views.goodsOrder.msg.sortFail': 'Sort update failed',

  'views.orderPayment.drawer.title': 'Order payments',
  'views.orderPayment.search.orderId': 'Order ID',
  'views.orderPayment.search.orderIdPlaceholder': 'Enter order ID',
  'views.orderPayment.search.money': 'Amount',
  'views.orderPayment.search.moneyPlaceholder': 'Enter amount',
  'views.orderPayment.search.sort': 'Sort',
  'views.orderPayment.search.sortPlaceholder': 'Enter sort value',
  'views.orderPayment.search.expand': 'Expand',
  'views.orderPayment.search.collapse': 'Collapse',
  'views.orderPayment.action.query': 'Search',
  'views.orderPayment.action.reset': 'Reset',
  'views.orderPayment.action.add': 'Add',
  'views.orderPayment.action.edit': 'Edit',
  'views.orderPayment.action.audit': 'Audit',
  'views.orderPayment.action.delete': 'Delete',
  'views.orderPayment.column.id': 'ID',
  'views.orderPayment.column.orderId': 'Order ID',
  'views.orderPayment.column.type': 'Type',
  'views.orderPayment.column.money': 'Amount',
  'views.orderPayment.column.url': 'Payment screenshot',
  'views.orderPayment.column.auditStatus': 'Audit status',
  'views.orderPayment.paymentType.full': 'Full payment screenshot',
  'views.orderPayment.paymentType.first': 'First payment screenshot',
  'views.orderPayment.paymentType.final': 'Final payment screenshot',
  'views.orderPayment.paymentType.unknown': 'Unknown ({value})',
  'views.orderPayment.auditStatus.pending': 'Pending',
  'views.orderPayment.auditStatus.approved': 'Approved',
  'views.orderPayment.auditStatus.rejected': 'Rejected',
  'views.orderPayment.auditStatus.unknown': 'Unknown ({value})',
  'views.orderPayment.column.auditReason': 'Audit reason',
  'views.orderPayment.column.auditReasonEn': 'Audit reason (English)',
  'views.orderPayment.column.sort': 'Sort',
  'views.orderPayment.column.status': 'Status',
  'views.orderPayment.column.createTime': 'Created at',
  'views.orderPayment.column.operation': 'Actions',
  'views.orderPayment.pagination.total': 'Total {total} items',
  'views.orderPayment.confirm.deleteTitle': 'Delete selected records?',
  'views.orderPayment.confirm.deleteContent': 'Selected IDs: {ids}',
  'views.orderPayment.msg.deleteOk': 'Deleted',
  'views.orderPayment.msg.statusOk': 'Status updated',
  'views.orderPayment.msg.statusFail': 'Status update failed',
  'views.orderPayment.msg.sortOk': 'Sort updated',
  'views.orderPayment.msg.sortFail': 'Sort update failed',
  'views.orderPayment.form.titleAdd': 'Add',
  'views.orderPayment.form.titleEdit': 'Edit',
  'views.orderPayment.form.orderId': 'Order ID',
  'views.orderPayment.form.orderIdPlaceholder': 'Enter order ID',
  'views.orderPayment.form.type': 'Type',
  'views.orderPayment.form.typePlaceholder': 'Select screenshot type',
  'views.orderPayment.form.money': 'Amount',
  'views.orderPayment.form.moneyPlaceholder': 'Enter amount',
  'views.orderPayment.form.url': 'Payment screenshot',
  'views.orderPayment.form.urlPlaceholder': 'Enter content',
  'views.orderPayment.form.auditStatus': 'Audit status',
  'views.orderPayment.form.auditStatusPlaceholder': 'Select audit status',
  'views.orderPayment.form.auditReason': 'Audit reason',
  'views.orderPayment.form.auditReasonPlaceholder': 'Enter content',
  'views.orderPayment.form.auditReasonEn': 'Audit reason (English)',
  'views.orderPayment.form.auditReasonEnPlaceholder': 'Enter audit reason in English',
  'views.orderPayment.form.save': 'Save',
  'views.orderPayment.form.cancel': 'Cancel',
  'views.orderPayment.msg.addOk': 'Created',
  'views.orderPayment.msg.addFail': 'Create failed',
  'views.orderPayment.msg.updateOk': 'Updated',
  'views.orderPayment.msg.updateFail': 'Update failed',

  'views.goods.search.category': 'Category',
  'views.goods.search.categoryPlaceholder': 'Select category',
  'views.goods.search.name': 'Name',
  'views.goods.search.namePlaceholder': 'Enter name',
  'views.goods.search.type': 'Product type',
  'views.goods.search.typePlaceholder': 'Select product type',
  'views.goods.type.0': 'Stand-up pouch',
  'views.goods.type.1': 'Three-side seal',
  'views.goods.btn.query': 'Search',
  'views.goods.btn.reset': 'Reset',
  'views.goods.btn.add': 'Add',
  'views.goods.btn.edit': 'Edit',
  'views.goods.btn.delete': 'Delete',
  'views.goods.column.id': 'ID',
  'views.goods.column.categoryName': 'Category',
  'views.goods.column.name': 'Name',
  'views.goods.column.type': 'Product type',
  'views.goods.column.imgUrl': 'Image',
  'views.goods.column.description': 'Description',
  'views.goods.column.content': 'Product details',
  'views.goods.column.sort': 'Sort',
  'views.goods.column.status': 'Status',
  'views.goods.column.createTime': 'Created at',
  'views.goods.column.operation': 'Actions',
  'views.goods.action.specSameManage': 'Selection',
  'views.goods.drawer.specSameTitle': 'Selection management',
  'views.goods.pagination.total': 'Total {total}',
  'views.goods.confirm.deleteTitle': 'Delete selected records?',
  'views.goods.confirm.deleteContent': 'Selected IDs: {ids}',
  'views.goods.msg.deleteSuccess': 'Deleted',
  'views.goods.confirm.exportTitle': 'Export?',
  'views.goods.confirm.exportContent': 'This will export all data matching current filters, not only selected rows.',
  'views.goods.export.filename': 'goods_{time}.xlsx',
  'views.goods.msg.statusOk': 'Status updated',
  'views.goods.msg.statusFail': 'Status update failed',
  'views.goods.msg.sortOk': 'Sort updated',
  'views.goods.msg.sortFail': 'Sort update failed',

  'views.goods.title.add': 'Add product',
  'views.goods.title.edit': 'Edit product',
  'views.goods.form.category': 'Category',
  'views.goods.form.categoryPlaceholder': 'Select category',
  'views.goods.form.type': 'Product type',
  'views.goods.form.typePlaceholder': 'Select product type',
  'views.goods.form.name': 'Name',
  'views.goods.form.namePlaceholder': 'Enter name',
  'views.goods.form.nameEn': 'Name (EN)',
  'views.goods.form.nameEnPlaceholder': 'Enter English name',
  'views.goods.form.spec': 'Specifications',
  'views.goods.form.specPlaceholder': 'Select specifications (multiple)',
  'views.goods.form.specFallback': 'Spec ({id})',
  'views.goods.form.tagCustom': 'Custom',
  'views.goods.form.tagPro': 'Pro user',
  'views.goods.form.sortLabel': 'Sort',
  'views.goods.form.selectAll': 'Select all',
  'views.goods.form.selectNone': 'Clear all',
  'views.goods.form.combSort': 'Sort',
  'views.goods.form.combCombo': 'Combination',
  'views.goods.form.combType': 'Type',
  'views.goods.form.combSingle': 'Single',
  'views.goods.form.combMulti': 'Multiple',
  'views.goods.form.combDefault': 'Default',
  'views.goods.form.optional': 'Optional',
  'views.goods.form.combPickItems': 'Select combination items',
  'views.goods.form.combGroupName': 'Combination name',
  'views.goods.form.combNamePlaceholder': 'Enter name',
  'views.goods.form.combGroupNameEn': 'Combination name (English)',
  'views.goods.form.combNameEnPlaceholder': 'Enter English name',
  'views.goods.form.combDelete': 'Remove',
  'views.goods.form.combAddRow': '+ Add combination row',
  'views.goods.form.combTitle': 'Combination {n}',
  'views.goods.form.specSelected': 'Selected {selected} / {total}',
  'views.goods.form.emptyNoOptions': 'No options',
  'views.goods.form.emptySelectSpec': 'Select specifications first',
  'views.goods.form.dividerSpecOptions': 'Spec options',
  'views.goods.form.dividerAssociation': 'Linked settings',
  'views.goods.form.addAssociation': 'Add link',
  'views.goods.form.associationHint': 'No links yet. Click “Add link”.',
  'views.goods.form.associationCardTitle': 'Link {n}',
  'views.goods.form.delete': 'Delete',
  'views.goods.form.assocSpec': 'Specification',
  'views.goods.form.assocSpecPlaceholder': 'Select specification',
  'views.goods.form.assocOption': 'Option',
  'views.goods.form.assocOptionPlaceholder': 'Select option value',
  'views.goods.form.assocTwoSpec': 'Linked specification',
  'views.goods.form.assocTwoSpecPlaceholder': 'Select linked specification',
  'views.goods.form.assocOptions': 'Linked options',
  'views.goods.form.assocOptionsPlaceholder': 'Select linked options (multiple)',
  'views.goods.form.assocDefault': 'Default',
  'views.goods.form.optionFallback': 'Option ({id})',
  'views.goods.form.compositeMaterials': 'Other cost (composite)',
  'views.goods.form.compositeMaterialsPlaceholder': 'Select (multi, searchable; options used in calculation)',
  'views.goods.form.compositeCost': 'Composite cost (material)',
  'views.goods.form.compositeCostPlaceholder': 'CNY/m/layer, max 2 decimals',
  'views.goods.form.passRate': 'Pass rate (composite)',
  'views.goods.form.passRatePlaceholder': 'Pass rate, max 2 decimals',
  'views.goods.form.toolIds': 'Cutting tools',
  'views.goods.form.toolIdsPlaceholder': 'Select tools (multi, searchable)',
  'views.goods.form.machineTuning': 'Other cost (machine setup)',
  'views.goods.form.machineTuningPlaceholder': 'Select (multi, searchable; options used in calculation)',
  'views.goods.form.machineCost': 'Composite cost (machine setup)',
  'views.goods.form.machineCostPlaceholder': 'CNY/m/layer, max 2 decimals',
  'views.goods.form.machineId': 'Setup meters (machine cost)',
  'views.goods.form.machineIdPlaceholder': 'Select setup meters (searchable)',
  'views.goods.form.printMultiples': 'Print multiples',
  'views.goods.form.printMultiplesPlaceholder': 'Select print multiples (searchable)',
  'views.goods.form.specialMultipleIds': 'Special multiples',
  'views.goods.form.specialMultipleIdsPlaceholder': 'Select special multiples (multi, searchable)',
  'views.goods.form.colorAdjustment': 'Color adjustment fee',
  'views.goods.form.colorAdjustmentPlaceholder': 'Fee, max 2 decimals',
  'views.goods.form.packagingFee': 'Media-resistant packaging fee',
  'views.goods.form.packagingFeePlaceholder': 'Fee, max 2 decimals',
  'views.goods.form.sealStripRemaining': 'Seal strip remainder (mm)',
  'views.goods.form.sealStripRemainingPlaceholder': 'Non-negative integer, millimeters, default 0',
  'views.goods.form.installationFee': 'Seal strip installation fee (per strip)',
  'views.goods.form.installationFeePlaceholder': 'Non-negative amount, 2 decimal places, default 0.00',
  'views.goods.form.url': 'Icon',
  'views.goods.form.description': 'Description',
  'views.goods.form.descriptionPlaceholder': 'Enter description',
  'views.goods.form.descriptionEn': 'Description (EN)',
  'views.goods.form.descriptionEnPlaceholder': 'English description (optional)',
  'views.goods.form.content': 'Product details',
  'views.goods.form.contentEn': 'Product details (EN)',
  'views.goods.form.save': 'Save',
  'views.goods.form.cancel': 'Cancel',
  'views.goods.rule.categoryRequired': 'Please select category',
  'views.goods.rule.typeRequired': 'Please select product type',
  'views.goods.rule.nameRequired': 'Name is required',
  'views.goods.msg.addOk': 'Created',
  'views.goods.msg.addFail': 'Create failed',
  'views.goods.msg.updateOk': 'Updated',
  'views.goods.msg.updateFail': 'Update failed',

  'views.goodsSpecSame.query.specCombinationList': 'Combination option IDs',
  'views.goodsSpecSame.query.specCombinationListPlaceholder': 'Enter IDs separated by commas',
  'views.goodsSpecSame.query.sort': 'Sort',
  'views.goodsSpecSame.query.sortPlaceholder': 'Enter sort value',
  'views.goodsSpecSame.btn.query': 'Search',
  'views.goodsSpecSame.btn.add': 'Add',
  'views.goodsSpecSame.btn.edit': 'Edit',
  'views.goodsSpecSame.btn.delete': 'Delete',
  'views.goodsSpecSame.column.id': 'ID',
  'views.goodsSpecSame.column.goodSpecName': 'Product spec',
  'views.goodsSpecSame.column.specOptionName': 'Selected spec option',
  'views.goodsSpecSame.column.specCombinationNameList': 'Combination options',
  'views.goodsSpecSame.column.status': 'Status',
  'views.goodsSpecSame.column.createTime': 'Created at',
  'views.goodsSpecSame.column.operation': 'Actions',
  'views.goodsSpecSame.pagination.total': 'Total {total}',
  'views.goodsSpecSame.confirm.deleteTitle': 'Delete selected records?',
  'views.goodsSpecSame.confirm.deleteContent': 'Selected IDs: {ids}',
  'views.goodsSpecSame.msg.deleteOk': 'Deleted',
  'views.goodsSpecSame.confirm.exportTitle': 'Export?',
  'views.goodsSpecSame.confirm.exportContent': 'This will export all data matching current filters, not only selected rows.',
  'views.goodsSpecSame.export.filenamePrefix': 'goods-spec-same',
  'views.goodsSpecSame.msg.statusOk': 'Status updated',
  'views.goodsSpecSame.msg.statusFail': 'Status update failed',
  'views.goodsSpecSame.msg.sortOk': 'Sort updated',
  'views.goodsSpecSame.msg.sortFail': 'Sort update failed',
  'views.goodsSpecSame.title.add': 'Add',
  'views.goodsSpecSame.title.edit': 'Edit',
  'views.goodsSpecSame.form.goodSpec': 'Product spec',
  'views.goodsSpecSame.form.goodSpecPlaceholder': 'Select product spec (searchable)',
  'views.goodsSpecSame.form.selectedOption': 'Selected spec option',
  'views.goodsSpecSame.form.specCombinationPlaceholder': 'Select combination (search by option name)',
  'views.goodsSpecSame.form.specCombinationPlaceholderDisabled': 'Select product spec first',
  'views.goodsSpecSame.form.combinationOptions': 'Combination options',
  'views.goodsSpecSame.form.combinationListPlaceholder': 'Select combination options (multi)',
  'views.goodsSpecSame.form.combinationListPlaceholderDisabled': 'Select product spec first',
  'views.goodsSpecSame.form.save': 'Save',
  'views.goodsSpecSame.form.cancel': 'Cancel',
  'views.goodsSpecSame.option.goodSpecRow': '{name} (spec row ID: {id})',
  'views.goodsSpecSame.option.goodSpecRowId': 'Spec row ID: {id}',
  'views.goodsSpecSame.option.comboRow': '{name} (combo ID: {id})',
  'views.goodsSpecSame.option.comboRowId': 'Combo ID: {id}',
  'views.goodsSpecSame.msg.addOk': 'Created',
  'views.goodsSpecSame.msg.addFail': 'Create failed',
  'views.goodsSpecSame.msg.updateOk': 'Updated',
  'views.goodsSpecSame.msg.updateFail': 'Update failed',

  'views.spec.search.name': 'Name',
  'views.spec.search.namePlaceholder': 'Enter name',
  'views.spec.search.isCalculation': 'Include in calculation',
  'views.spec.search.isCalculationPlaceholder': 'Select',
  'views.spec.search.isConflict': 'Conflict',
  'views.spec.search.isConflictPlaceholder': 'Select',
  'views.spec.search.type': 'Type',
  'views.spec.search.typePlaceholder': 'Select type',
  'views.spec.search.isRequired': 'Required',
  'views.spec.search.isRequiredPlaceholder': 'Select',
  'views.spec.search.isCustomization': 'Customizable',
  'views.spec.search.isCustomizationPlaceholder': 'Select',
  'views.spec.search.identityRestrictions': 'User type',
  'views.spec.search.identityRestrictionsPlaceholder': 'Select user type',
  'views.spec.search.isPrompt': 'Show prompt',
  'views.spec.search.isPromptPlaceholder': 'Select',
  'views.spec.search.isDensity': 'Density material',
  'views.spec.search.isDensityPlaceholder': 'Select',
  'views.spec.search.isThickness': 'Fixed thickness',
  'views.spec.search.isThicknessPlaceholder': 'Select',
  'views.spec.search.isShow': 'Visible',
  'views.spec.search.isShowPlaceholder': 'Select',
  'views.spec.btn.query': 'Search',
  'views.spec.btn.reset': 'Reset',
  'views.spec.btn.add': 'Add',
  'views.spec.btn.edit': 'Edit',
  'views.spec.btn.delete': 'Delete',
  'views.spec.enum.no': 'No',
  'views.spec.enum.yes': 'Yes',
  'views.spec.enum.calcNo': 'No',
  'views.spec.enum.calcYes': 'Yes',
  'views.spec.enum.requiredNo': 'Optional',
  'views.spec.enum.requiredYes': 'Required',
  'views.spec.enum.promptNo': 'No',
  'views.spec.enum.promptYes': 'Yes',
  'views.spec.enum.identityNormal': 'Normal user',
  'views.spec.enum.identityPro': 'Pro customer',
  'views.spec.enum.typeSingle': 'Single',
  'views.spec.enum.typeMulti': 'Multiple',
  'views.spec.column.id': 'ID',
  'views.spec.column.name': 'Name',
  'views.spec.column.nameEn': 'Name (EN)',
  'views.spec.column.isCalculation': 'In calculation',
  'views.spec.column.isConflict': 'Conflict',
  'views.spec.column.type': 'Type',
  'views.spec.column.isRequired': 'Required',
  'views.spec.column.isCustomization': 'Customizable',
  'views.spec.column.identityRestrictions': 'User type',
  'views.spec.column.isPrompt': 'Prompt',
  'views.spec.column.isDensity': 'Density material',
  'views.spec.column.isThickness': 'Fixed thickness',
  'views.spec.column.isShow': 'Visible',
  'views.spec.column.sort': 'Sort',
  'views.spec.column.status': 'Status',
  'views.spec.column.createTime': 'Created at',
  'views.spec.column.operation': 'Actions',
  'views.spec.pagination.total': 'Total {total}',
  'views.spec.action.optionList': 'Options',
  'views.spec.confirm.deleteTitle': 'Delete selected records?',
  'views.spec.confirm.deleteContent': 'Selected IDs: {ids}',
  'views.spec.msg.deleteSuccess': 'Deleted',
  'views.spec.confirm.exportTitle': 'Export data?',
  'views.spec.confirm.exportContent': 'Exports all data matching current filters, not only selected rows.',
  'views.spec.export.filename': 'spec_{time}.xlsx',
  'views.spec.msg.statusOk': 'Status updated',
  'views.spec.msg.statusFail': 'Status update failed',
  'views.spec.msg.sortOk': 'Sort updated',
  'views.spec.msg.sortFail': 'Sort update failed',

  'views.spec.form.isRequired': 'Required',
  'views.spec.form.isRequiredPlaceholder': 'Select',
  'views.spec.form.type': 'Type',
  'views.spec.form.typePlaceholder': 'Select type',
  'views.spec.form.name': 'Name',
  'views.spec.form.namePlaceholder': 'Enter name',
  'views.spec.form.nameEn': 'Name (EN)',
  'views.spec.form.nameEnPlaceholder': 'Enter English name',
  'views.spec.form.isCalculation': 'Include in calculation',
  'views.spec.form.isCalculationPlaceholder': 'Select',
  'views.spec.form.isConflict': 'Conflict',
  'views.spec.form.isConflictPlaceholder': 'Select',
  'views.spec.form.isCustomization': 'Customizable',
  'views.spec.form.isCustomizationPlaceholder': 'Select',
  'views.spec.form.identityRestrictions': 'User type',
  'views.spec.form.identityRestrictionsPlaceholder': 'Select',
  'views.spec.form.isDensity': 'Density material',
  'views.spec.form.isDensityPlaceholder': 'Select',
  'views.spec.form.isThickness': 'Fixed thickness',
  'views.spec.form.isThicknessPlaceholder': 'Select',
  'views.spec.form.isShow': 'Visible',
  'views.spec.form.isShowPlaceholder': '0 = hidden, 1 = shown',
  'views.spec.form.dividerOptions': 'Spec options',
  'views.spec.form.addOption': 'Add option',
  'views.spec.form.emptyOptions': 'No options yet. Click “Add option”.',
  'views.spec.form.optionTitle': 'Option {n}',
  'views.spec.form.removeOption': 'Remove',
  'views.spec.form.optionName': 'Name',
  'views.spec.form.optionNamePlaceholder': 'Enter option name',
  'views.spec.form.optionNameEn': 'Name (EN)',
  'views.spec.form.optionNameEnPlaceholder': 'Enter English name',
  'views.spec.form.optionSort': 'Sort',
  'views.spec.form.optionIsConflict': 'Conflict',
  'views.spec.form.selectPlaceholder': 'Select',
  'views.spec.form.optionRemark': 'Remark',
  'views.spec.form.optionRemarkPlaceholder': 'Enter remark',
  'views.spec.form.optionRemarkEn': 'Remark (EN)',
  'views.spec.form.optionRemarkEnPlaceholder': 'English remark (optional)',
  'views.spec.form.materialDensity': 'Material density',
  'views.spec.form.membraneWidth': 'Film width',
  'views.spec.form.materialThickness': 'Material thickness',
  'views.spec.form.sellingPrice': 'Selling price',
  'views.spec.form.manuscriptFee': 'Plate charge per item',
  'views.spec.form.costPrice': 'Cost price',
  'views.spec.form.optionLaborCosts': 'Zipper pull & labor (CNY/pc)',
  'views.spec.form.optionLaborCostsSealStrip': 'Labor fee',
  'views.spec.form.optionLaborWeight': 'Zipper pull weight (g/pc)',
  'views.spec.form.optionWeight': 'Weight (g)',
  'views.spec.form.optionUnit': 'Unit',
  'views.spec.form.optionUnitPlaceholder': 'Enter unit',
  'views.spec.form.valueLabel': 'Value',
  'views.spec.form.isPrompt': 'Show prompt',
  'views.spec.form.isPromptPlaceholder': 'Select',
  'views.spec.form.imagePrompt': 'Image (prompt)',
  'views.spec.form.imageUrlPlaceholder': 'Enter image URL',
  'views.spec.form.contentPrompt': 'Description (prompt)',
  'views.spec.form.contentPromptPlaceholder': 'Enter description',
  'views.spec.form.contentEnPrompt': 'Description (EN)',
  'views.spec.form.contentEnPromptPlaceholder': 'English description (optional)',
  'views.spec.form.defaultOption': 'Default',
  'views.spec.form.defaultOptionPlaceholder': 'Select default (from child options)',
  'views.spec.form.save': 'Save',
  'views.spec.form.cancel': 'Cancel',
  'views.spec.rule.nameRequired': 'Name is required',
  'views.spec.rule.optionNameRequired': 'Enter option name',
  'views.spec.rule.uploadImage': 'Please upload image',
  'views.spec.rule.contentRequired': 'Enter description',
  'views.spec.title.add': 'Add',
  'views.spec.title.edit': 'Edit',
  'views.spec.msg.addOk': 'Created',
  'views.spec.msg.addFail': 'Create failed',
  'views.spec.msg.updateOk': 'Updated',
  'views.spec.msg.updateFail': 'Update failed',

  'views.specOption.drawerTitle': 'Spec options',
  'views.specOption.btn.query': 'Search',
  'views.specOption.btn.reset': 'Reset',
  'views.specOption.btn.add': 'Add',
  'views.specOption.btn.edit': 'Edit',
  'views.specOption.btn.view': 'View',
  'views.specOption.btn.delete': 'Delete',
  'views.specOption.expand': 'Expand',
  'views.specOption.collapse': 'Collapse',
  'views.specOption.pagination.total': 'Total {total}',
  'views.specOption.query.specId': 'Spec',
  'views.specOption.query.specIdPlaceholder': 'Enter spec ID',
  'views.specOption.query.name': 'Name',
  'views.specOption.query.namePlaceholder': 'Enter name',
  'views.specOption.query.parentId': 'Parent option ID (0 = top level)',
  'views.specOption.query.parentIdPlaceholder': 'Enter parent option ID, 0 for top level',
  'views.specOption.query.isCalculation': 'In calculation: 0 no, 1 yes',
  'views.specOption.query.isCalculationPlaceholder': 'Enter 0 or 1',
  'views.specOption.query.isRequired': 'Required: 0 no, 1 yes',
  'views.specOption.query.isRequiredPlaceholder': 'Enter 0 or 1',
  'views.specOption.query.isConflict': 'Conflict: 0 no, 1 yes',
  'views.specOption.query.isConflictPlaceholder': 'Enter 0 or 1',
  'views.specOption.query.isCustomization': 'Customizable: 0 no, 1 yes',
  'views.specOption.query.isCustomizationPlaceholder': 'Enter 0 or 1',
  'views.specOption.query.identityRestrictions': 'User type: 0 normal, 1 pro',
  'views.specOption.query.identityRestrictionsPlaceholder': 'Enter 0 or 1',
  'views.specOption.query.isPrompt': 'Prompt: 0 off, 1 on',
  'views.specOption.query.isPromptPlaceholder': 'Enter 0 or 1',
  'views.specOption.query.defaultOption': 'Default value',
  'views.specOption.query.defaultOptionPlaceholder': 'Enter default value',
  'views.specOption.query.sellingPrice': 'Selling price',
  'views.specOption.query.sellingPricePlaceholder': 'Enter selling price',
  'views.specOption.query.costPrice': 'Cost price',
  'views.specOption.query.costPricePlaceholder': 'Enter cost price',
  'views.specOption.query.materialDensity': 'Material density',
  'views.specOption.query.materialDensityPlaceholder': 'Enter material density',
  'views.specOption.query.membraneWidth': 'Film width',
  'views.specOption.query.membraneWidthPlaceholder': 'Enter film width',
  'views.specOption.query.isThickness': 'Fixed thickness: 0 no, 1 yes',
  'views.specOption.query.isThicknessPlaceholder': 'Enter 0 or 1',
  'views.specOption.query.materialThickness': 'Material thickness',
  'views.specOption.query.materialThicknessPlaceholder': 'Enter material thickness',
  'views.specOption.query.url': 'Image',
  'views.specOption.query.urlPlaceholder': 'Enter image URL',
  'views.specOption.query.sort': 'Sort',
  'views.specOption.query.sortPlaceholder': 'Enter sort',
  'views.specOption.column.id': 'ID',
  'views.specOption.column.name': 'Name',
  'views.specOption.column.nameEn': 'Name (EN)',
  'views.specOption.column.isConflict': 'Conflict',
  'views.specOption.column.remark': 'Remark',
  'views.specOption.column.isPrompt': 'Prompt',
  'views.specOption.column.url': 'Image (prompt)',
  'views.specOption.column.content': 'Description (prompt)',
  'views.specOption.column.sellingPrice': 'Selling price',
  'views.specOption.column.costPrice': 'Cost price',
  'views.specOption.column.manuscriptFee': 'Plate charge per item',
  'views.specOption.column.materialDensity': 'Material density',
  'views.specOption.column.membraneWidth': 'Film width',
  'views.specOption.column.isThickness': 'Fixed thickness',
  'views.specOption.column.materialThickness': 'Material thickness',
  'views.specOption.column.sort': 'Sort',
  'views.specOption.column.status': 'Status',
  'views.specOption.column.createTime': 'Created at',
  'views.specOption.column.operation': 'Actions',
  'views.specOption.format.yes': 'Yes',
  'views.specOption.format.no': 'No',
  'views.specOption.format.promptOn': 'On',
  'views.specOption.format.promptOff': 'Off',
  'views.specOption.confirm.deleteTitle': 'Delete selected records?',
  'views.specOption.confirm.deleteContent': 'Selected IDs: {ids}',
  'views.specOption.msg.deleteOk': 'Deleted',
  'views.specOption.confirm.exportTitle': 'Export data?',
  'views.specOption.confirm.exportContent': 'Exports all data matching current filters, not only selected rows.',
  'views.specOption.export.filenamePrefix': 'spec_options_tree',
  'views.specOption.msg.statusOk': 'Status updated',
  'views.specOption.msg.statusFail': 'Status update failed',
  'views.specOption.msg.sortOk': 'Sort updated',
  'views.specOption.msg.sortFail': 'Sort update failed',
  'views.specOption.form.specIdLabel': 'Spec',
  'views.specOption.form.specIdPlaceholder': 'Enter spec ID',
  'views.specOption.form.parentId': 'Parent option ID',
  'views.specOption.form.parentIdPlaceholder': 'Enter parent ID (0 = top level)',
  'views.specOption.form.isCalculationInput': 'In calculation',
  'views.specOption.form.isCalculationInputPlaceholder': 'Enter in-calculation flag',
  'views.specOption.form.isRequiredInput': 'Required',
  'views.specOption.form.isRequiredInputPlaceholder': 'Enter required flag',
  'views.specOption.form.type': 'Type',
  'views.specOption.form.defaultOptionValuePlaceholder': 'Enter default option value',

  'views.machine.search.name': 'Name',
  'views.machine.search.namePlaceholder': 'Enter name',
  'views.machine.btn.query': 'Search',
  'views.machine.btn.reset': 'Reset',
  'views.machine.btn.add': 'Add',
  'views.machine.btn.edit': 'Edit',
  'views.machine.btn.delete': 'Delete',
  'views.machine.column.id': 'ID',
  'views.machine.column.name': 'Name',
  'views.machine.column.machineMeter': 'Meters',
  'views.machine.column.doubleMeter': 'Double feed',
  'views.machine.column.bottomMeter': 'Bottom',
  'views.machine.column.sort': 'Sort',
  'views.machine.column.status': 'Status',
  'views.machine.column.createTime': 'Created at',
  'views.machine.column.operation': 'Actions',
  'views.machine.pagination.total': 'Total {total}',
  'views.machine.confirm.deleteTitle': 'Delete selected records?',
  'views.machine.confirm.deleteContent': 'Selected IDs: {ids}',
  'views.machine.msg.deleteSuccess': 'Deleted',
  'views.machine.confirm.exportTitle': 'Export data?',
  'views.machine.confirm.exportContent': 'Exports all data matching current filters, not only selected rows.',
  'views.machine.export.filename': 'machine_meters_{time}.xlsx',
  'views.machine.msg.statusOk': 'Status updated',
  'views.machine.msg.statusFail': 'Status update failed',
  'views.machine.msg.sortOk': 'Sort updated',
  'views.machine.msg.sortFail': 'Sort update failed',
  'views.machine.form.name': 'Name',
  'views.machine.form.namePlaceholder': 'Enter name',
  'views.machine.form.machineMeter': 'Meters',
  'views.machine.form.machineMeterPlaceholder': 'Enter meters',
  'views.machine.form.doubleMeter': 'Double feed',
  'views.machine.form.doubleMeterPlaceholder': 'Enter double-feed value',
  'views.machine.form.bottomMeter': 'Bottom',
  'views.machine.form.bottomMeterPlaceholder': 'Enter bottom value',
  'views.machine.form.save': 'Save',
  'views.machine.form.cancel': 'Cancel',
  'views.machine.rule.nameRequired': 'Name is required',
  'views.machine.title.add': 'Add',
  'views.machine.title.edit': 'Edit',
  'views.machine.msg.addOk': 'Created',
  'views.machine.msg.addFail': 'Create failed',
  'views.machine.msg.updateOk': 'Updated',
  'views.machine.msg.updateFail': 'Update failed',

  'views.printMultiples.search.name': 'Name',
  'views.printMultiples.search.namePlaceholder': 'Enter name',
  'views.printMultiples.btn.query': 'Search',
  'views.printMultiples.btn.reset': 'Reset',
  'views.printMultiples.btn.add': 'Add',
  'views.printMultiples.btn.edit': 'Edit',
  'views.printMultiples.btn.delete': 'Delete',
  'views.printMultiples.column.id': 'ID',
  'views.printMultiples.column.name': 'Name',
  'views.printMultiples.column.price': 'Min order price',
  'views.printMultiples.column.recyclingPrice': 'Recyclable min order price',
  'views.printMultiples.column.andDoubleNum': '×2',
  'views.printMultiples.column.andBottomNum': 'Bottom',
  'views.printMultiples.column.andThreeNum': '×3',
  'views.printMultiples.column.andFourNum': '×4',
  'views.printMultiples.column.doubleDischarging': 'Double feed',
  'views.printMultiples.column.sort': 'Sort',
  'views.printMultiples.column.status': 'Status',
  'views.printMultiples.column.createTime': 'Created at',
  'views.printMultiples.column.operation': 'Actions',
  'views.printMultiples.pagination.total': 'Total {total}',
  'views.printMultiples.action.optionLink': 'Options',
  'views.printMultiples.drawer.optionLinkTitle': 'Option mapping',
  'views.printMultiples.confirm.deleteTitle': 'Delete selected records?',
  'views.printMultiples.confirm.deleteContent': 'Selected IDs: {ids}',
  'views.printMultiples.msg.deleteSuccess': 'Deleted',
  'views.printMultiples.confirm.exportTitle': 'Export data?',
  'views.printMultiples.confirm.exportContent': 'Exports all data matching current filters, not only selected rows.',
  'views.printMultiples.export.filename': 'print_multiples_{time}.xlsx',
  'views.printMultiples.msg.statusOk': 'Status updated',
  'views.printMultiples.msg.statusFail': 'Status update failed',
  'views.printMultiples.msg.sortOk': 'Sort updated',
  'views.printMultiples.msg.sortFail': 'Sort update failed',
  'views.printMultiples.form.name': 'Name',
  'views.printMultiples.form.namePlaceholder': 'Enter name',
  'views.printMultiples.form.price': 'Min order price',
  'views.printMultiples.form.recyclingPrice': 'Recyclable min order price',
  'views.printMultiples.form.andDoubleNum': '×2',
  'views.printMultiples.form.andBottomNum': 'Bottom',
  'views.printMultiples.form.andThreeNum': '×3',
  'views.printMultiples.form.andFourNum': '×4',
  'views.printMultiples.form.doubleDischarging': 'Double feed',
  'views.printMultiples.form.save': 'Save',
  'views.printMultiples.form.cancel': 'Cancel',
  'views.printMultiples.title.add': 'Add',
  'views.printMultiples.title.edit': 'Edit',
  'views.printMultiples.msg.addOk': 'Created',
  'views.printMultiples.msg.addFail': 'Create failed',
  'views.printMultiples.msg.updateOk': 'Updated',
  'views.printMultiples.msg.updateFail': 'Update failed',
  'views.printMultiples.action.specialMinimum': 'Special minimum',
  'views.printMultiples.drawer.specialMinimumTitle': 'Special minimum ({name})',

  'views.specialMinimum.search.printMultiplesId': 'Print multiples ID',
  'views.specialMinimum.search.printMultiplesIdPlaceholder': 'Enter print multiples ID',
  'views.specialMinimum.search.specOptionId': 'Spec option ID',
  'views.specialMinimum.search.specOptionIdPlaceholder': 'Enter spec option ID',
  'views.specialMinimum.search.specOptionSelectPlaceholder': 'Select or search spec option',
  'views.specialMinimum.search.price': 'Min order price',
  'views.specialMinimum.search.pricePlaceholder': 'Enter min order price',
  'views.specialMinimum.search.sort': 'Sort',
  'views.specialMinimum.search.sortPlaceholder': 'Enter sort',
  'views.specialMinimum.btn.query': 'Search',
  'views.specialMinimum.btn.reset': 'Reset',
  'views.specialMinimum.btn.expand': 'Expand',
  'views.specialMinimum.btn.collapse': 'Collapse',
  'views.specialMinimum.btn.add': 'Add',
  'views.specialMinimum.btn.edit': 'Edit',
  'views.specialMinimum.btn.delete': 'Delete',
  'views.specialMinimum.btn.refresh': 'Refresh',
  'views.specialMinimum.column.id': 'ID',
  'views.specialMinimum.column.printMultiplesId': 'Print multiples ID',
  'views.specialMinimum.column.specOptionId': 'Spec option ID',
  'views.specialMinimum.column.specOptionName': 'Spec option',
  'views.specialMinimum.column.price': 'Min order price',
  'views.specialMinimum.column.sort': 'Sort',
  'views.specialMinimum.column.status': 'Status',
  'views.specialMinimum.column.createTime': 'Created at',
  'views.specialMinimum.column.operation': 'Actions',
  'views.specialMinimum.pagination.total': 'Total {total}',
  'views.specialMinimum.confirm.deleteTitle': 'Delete selected records?',
  'views.specialMinimum.confirm.deleteContent': 'Selected IDs: {ids}',
  'views.specialMinimum.msg.deleteSuccess': 'Deleted',
  'views.specialMinimum.msg.statusOk': 'Status updated',
  'views.specialMinimum.msg.statusFail': 'Status update failed',
  'views.specialMinimum.msg.sortOk': 'Sort updated',
  'views.specialMinimum.msg.sortFail': 'Sort update failed',
  'views.specialMinimum.form.printMultiplesId': 'Print multiples ID',
  'views.specialMinimum.form.printMultiplesIdPlaceholder': 'Enter print multiples ID',
  'views.specialMinimum.form.specOptionId': 'Spec option ID',
  'views.specialMinimum.form.specOptionIdPlaceholder': 'Enter spec option ID',
  'views.specialMinimum.form.specOptionSelectPlaceholder': 'Select or search spec option',
  'views.specialMinimum.form.price': 'Min order price',
  'views.specialMinimum.form.pricePlaceholder': 'Enter min order price',
  'views.specialMinimum.form.save': 'Save',
  'views.specialMinimum.form.cancel': 'Cancel',
  'views.specialMinimum.title.add': 'Add',
  'views.specialMinimum.title.edit': 'Edit',
  'views.specialMinimum.msg.addOk': 'Created',
  'views.specialMinimum.msg.addFail': 'Create failed',
  'views.specialMinimum.msg.updateOk': 'Updated',
  'views.specialMinimum.msg.updateFail': 'Update failed',

  'views.printMultiplesOption.search.multipleNum': 'Multiple',
  'views.printMultiplesOption.search.multipleNumPlaceholder': 'Enter multiple',
  'views.printMultiplesOption.search.sort': 'Sort',
  'views.printMultiplesOption.search.sortPlaceholder': 'Enter sort',
  'views.printMultiplesOption.btn.query': 'Search',
  'views.printMultiplesOption.btn.add': 'Add',
  'views.printMultiplesOption.btn.edit': 'Edit',
  'views.printMultiplesOption.btn.delete': 'Delete',
  'views.printMultiplesOption.column.id': 'ID',
  'views.printMultiplesOption.column.metersNum': 'Meters',
  'views.printMultiplesOption.column.multipleNum': 'Multiple',
  'views.printMultiplesOption.column.sort': 'Sort',
  'views.printMultiplesOption.column.status': 'Status',
  'views.printMultiplesOption.column.createTime': 'Created at',
  'views.printMultiplesOption.column.operation': 'Actions',
  'views.printMultiplesOption.pagination.total': 'Total {total}',
  'views.printMultiplesOption.confirm.deleteTitle': 'Delete selected records?',
  'views.printMultiplesOption.confirm.deleteContent': 'Selected IDs: {ids}',
  'views.printMultiplesOption.msg.deleteSuccess': 'Deleted',
  'views.printMultiplesOption.confirm.exportTitle': 'Export data?',
  'views.printMultiplesOption.confirm.exportContent': 'Exports all data matching current filters, not only selected rows.',
  'views.printMultiplesOption.export.filename': 'print_multiple_options_{time}.xlsx',
  'views.printMultiplesOption.msg.statusOk': 'Status updated',
  'views.printMultiplesOption.msg.statusFail': 'Status update failed',
  'views.printMultiplesOption.msg.sortOk': 'Sort updated',
  'views.printMultiplesOption.msg.sortFail': 'Sort update failed',
  'views.printMultiplesOption.form.metersNum': 'Meters',
  'views.printMultiplesOption.form.metersNumPlaceholder': 'Integer meters',
  'views.printMultiplesOption.form.multipleNum': 'Multiple',
  'views.printMultiplesOption.form.multipleNumPlaceholder': 'Multiple (max 2 decimals)',
  'views.printMultiplesOption.form.save': 'Save',
  'views.printMultiplesOption.form.cancel': 'Cancel',
  'views.printMultiplesOption.title.add': 'Add',
  'views.printMultiplesOption.title.edit': 'Edit',
  'views.printMultiplesOption.msg.addOk': 'Created',
  'views.printMultiplesOption.msg.addFail': 'Create failed',
  'views.printMultiplesOption.msg.updateOk': 'Updated',
  'views.printMultiplesOption.msg.updateFail': 'Update failed',

  'views.cuttingTool.search.name': 'Name',
  'views.cuttingTool.search.namePlaceholder': 'Enter name',
  'views.cuttingTool.btn.query': 'Search',
  'views.cuttingTool.btn.reset': 'Reset',
  'views.cuttingTool.btn.add': 'Add',
  'views.cuttingTool.btn.edit': 'Edit',
  'views.cuttingTool.btn.delete': 'Delete',
  'views.cuttingTool.column.id': 'ID',
  'views.cuttingTool.column.name': 'Name',
  'views.cuttingTool.column.bagWidth': 'Bag width',
  'views.cuttingTool.column.toolingFee': 'Tooling fee',
  'views.cuttingTool.column.comparisonSymbols': 'Comparator',
  'views.cuttingTool.column.sort': 'Sort',
  'views.cuttingTool.column.status': 'Status',
  'views.cuttingTool.column.createTime': 'Created at',
  'views.cuttingTool.column.operation': 'Actions',
  'views.cuttingTool.pagination.total': 'Total {total}',
  'views.cuttingTool.confirm.deleteTitle': 'Delete selected records?',
  'views.cuttingTool.confirm.deleteContent': 'Selected IDs: {ids}',
  'views.cuttingTool.msg.deleteSuccess': 'Deleted',
  'views.cuttingTool.confirm.exportTitle': 'Export data?',
  'views.cuttingTool.confirm.exportContent': 'Exports all data matching current filters, not only selected rows.',
  'views.cuttingTool.export.filename': 'cutting_tools_{time}.xlsx',
  'views.cuttingTool.msg.statusOk': 'Status updated',
  'views.cuttingTool.msg.statusFail': 'Status update failed',
  'views.cuttingTool.msg.sortOk': 'Sort updated',
  'views.cuttingTool.msg.sortFail': 'Sort update failed',
  'views.cuttingTool.form.name': 'Name',
  'views.cuttingTool.form.namePlaceholder': 'Enter name',
  'views.cuttingTool.form.bagWidth': 'Bag width',
  'views.cuttingTool.form.bagWidthPlaceholder': 'Enter bag width',
  'views.cuttingTool.form.toolingFee': 'Tooling fee',
  'views.cuttingTool.form.toolingFeePlaceholder': 'Enter tooling fee',
  'views.cuttingTool.form.comparisonSymbols': 'Comparator',
  'views.cuttingTool.form.comparisonSymbolsPlaceholder': 'Select comparator',
  'views.cuttingTool.form.save': 'Save',
  'views.cuttingTool.form.cancel': 'Cancel',
  'views.cuttingTool.title.add': 'Add',
  'views.cuttingTool.title.edit': 'Edit',
  'views.cuttingTool.msg.addOk': 'Created',
  'views.cuttingTool.msg.addFail': 'Create failed',
  'views.cuttingTool.msg.updateOk': 'Updated',
  'views.cuttingTool.msg.updateFail': 'Update failed',

  'views.account.settings.menuBase': 'Basic',
  'views.account.settings.menuSecurity': 'Security',
  'views.account.settings.titleBase': 'Basic settings',
  'views.account.settings.titleSecurity': 'Security settings',

  'views.account.base.nickName': 'Nickname',
  'views.account.base.nickNamePlaceholder': 'Choose a display name',
  'views.account.base.phone': 'Mobile',
  'views.account.base.phonePlaceholder': 'Phone number',
  'views.account.base.email': 'Email',
  'views.account.base.emailPlaceholder': 'Email address',
  'views.account.base.sex': 'Gender',
  'views.account.base.sexMale': 'Male',
  'views.account.base.sexFemale': 'Female',
  'views.account.base.save': 'Save',
  'views.account.base.rule.nickNameRequired': 'Please enter nickname',
  'views.account.base.rule.emailRequired': 'Email is required',
  'views.account.base.rule.emailFormat': 'Please enter a valid email',
  'views.account.base.rule.phoneRequired': 'Phone is required',
  'views.account.base.rule.phoneFormat': 'Please enter a valid mobile number',
  'views.account.base.notifyTitle': 'Notice',
  'views.account.base.notifyDescSuccess': 'Profile updated',

  'views.account.security.passwordTitle': 'Password',
  'views.account.security.passwordDesc': 'Current strength',
  'views.account.security.strengthStrong': 'Strong',
  'views.account.security.edit': 'Change',

  'views.account.password.title': 'Reset password',
  'views.account.password.old': 'Current password',
  'views.account.password.oldPlaceholder': 'Enter current password',
  'views.account.password.new': 'New password',
  'views.account.password.newPlaceholder': 'Enter new password',
  'views.account.password.confirm': 'Confirm password',
  'views.account.password.confirmPlaceholder': 'Confirm new password',
  'views.account.password.rule.oldRequired': 'Password is required',
  'views.account.password.rule.newRequired': 'Enter new password',
  'views.account.password.rule.newPattern': '5–20 characters: letters, digits, or symbols (no spaces); at least two of letter, digit, and punctuation',
  'views.account.password.rule.confirmRequired': 'Confirm new password',
  'views.account.password.rule.confirmMismatch': 'Passwords do not match',
  'views.account.password.msgSuccess': 'Password updated',

  'views.account.avatar.title': 'Change avatar',
  'views.account.avatar.selectImage': 'Choose image',
  'views.account.avatar.save': 'Save',
  'views.account.avatar.uploadSuccess': 'Upload successful',
  'views.account.avatar.msgSuccess': 'Avatar updated',

  'views.account.app.activeUsers': 'Active users',
  'views.account.app.newUsers': 'New users',
  'views.account.app.unitTenThousand': '10k',

  'views.account.article.tagAntDesign': 'Ant Design',
  'views.account.article.tagDesignLanguage': 'Design language',
  'views.account.article.tagAntFin': 'Ant Group',
  'views.account.article.loadMore': 'Load more',
  'views.account.article.demoDescription': 'During product development, different design specs appear; similar pages and components are often extracted into a shared system.',
  'views.account.article.demoTitle': 'Alipay',
  'views.account.article.demoOwner': 'Demo user',

  'views.account.center.tabArticle': 'Articles ({n})',
  'views.account.center.tabApp': 'Apps ({n})',
  'views.account.center.tabProject': 'Projects ({n})',
  'views.account.center.demoTag1': 'Thoughtful',
  'views.account.center.demoTag2': 'Design focused',
  'views.account.center.demoTag3': 'Spicy~',
  'views.account.center.demoTag4': 'Long legs',
  'views.account.center.demoTag5': 'Sichuan',
  'views.account.center.demoTag6': 'Open-minded',

  'components.avatarDropdown.logout': 'Log out',
  'components.avatarDropdown.logoutConfirmTitle': 'Confirm',
  'components.avatarDropdown.logoutConfirmContent': 'Are you sure you want to log out?',

  'views.bizCancel.search.email': 'Email',
  'views.bizCancel.search.emailPlaceholder': 'Enter email',
  'views.bizCancel.search.status': 'Review status',
  'views.bizCancel.search.statusPlaceholder': 'Select status',
  'views.bizCancel.search.reason': 'Reason for cancellation',
  'views.bizCancel.search.reasonPlaceholder': 'Enter reason',
  'views.bizCancel.search.failReason': 'Rejection reason',
  'views.bizCancel.search.failReasonPlaceholder': 'Enter rejection reason',
  'views.bizCancel.search.examineName': 'Reviewer',
  'views.bizCancel.search.examineNamePlaceholder': 'Enter reviewer name',
  'views.bizCancel.btn.query': 'Search',
  'views.bizCancel.btn.reset': 'Reset',
  'views.bizCancel.btn.edit': 'Edit',
  'views.bizCancel.btn.delete': 'Delete',
  'views.bizCancel.column.email': 'Cancel email',
  'views.bizCancel.column.userEmail': 'User email',
  'views.bizCancel.column.reason': 'Reason',
  'views.bizCancel.column.status': 'Status',
  'views.bizCancel.column.failReason': 'Rejection reason',
  'views.bizCancel.column.examineName': 'Reviewer',
  'views.bizCancel.column.examineTime': 'Reviewed at',
  'views.bizCancel.column.cancelTime': 'Requested at',
  'views.bizCancel.column.operation': 'Actions',
  'views.bizCancel.pagination.total': 'Total {total}',
  'views.bizCancel.confirm.deleteTitle': 'Delete selected records?',
  'views.bizCancel.confirm.deleteContent': 'Selected IDs: {ids}',
  'views.bizCancel.msg.deleteSuccess': 'Deleted',
  'views.bizCancel.confirm.exportTitle': 'Export data?',
  'views.bizCancel.confirm.exportContent': 'Exports all data matching current filters, not only selected rows.',
  'views.bizCancel.export.filename': 'user_cancel_{time}.xlsx',
  'views.bizCancel.form.email': 'Cancel email',
  'views.bizCancel.form.emailPlaceholder': 'Cancel email',
  'views.bizCancel.form.reason': 'Reason for cancellation',
  'views.bizCancel.form.reasonPlaceholder': 'Reason',
  'views.bizCancel.form.status': 'Review status',
  'views.bizCancel.form.statusPlaceholder': 'Select status',
  'views.bizCancel.form.failReason': 'Rejection reason',
  'views.bizCancel.form.failReasonPlaceholder': 'Rejection reason',
  'views.bizCancel.form.save': 'Save',
  'views.bizCancel.form.cancel': 'Cancel',
  'views.bizCancel.rule.mobileRequired': 'Phone is required',
  'views.bizCancel.rule.mobileFormat': 'Enter a valid mobile number',
  'views.bizCancel.rule.reasonRequired': 'Reason is required',
  'views.bizCancel.rule.statusRequired': 'Status is required',
  'views.bizCancel.title.add': 'Add',
  'views.bizCancel.title.audit': 'Review',
  'views.bizCancel.msg.updateOk': 'Updated',
  'views.bizCancel.msg.addOk': 'Created',

  'views.orderSettlement.search.userId': 'User ID',
  'views.orderSettlement.search.userIdPlaceholder': 'Enter user ID',
  'views.orderSettlement.search.orderNo': 'Settlement No.',
  'views.orderSettlement.search.orderNoPlaceholder': 'Enter settlement number',
  'views.orderSettlement.search.email': 'User email',
  'views.orderSettlement.search.emailPlaceholder': 'Enter user email',
  'views.orderSettlement.search.nickname': 'User nickname',
  'views.orderSettlement.search.nicknamePlaceholder': 'Enter nickname',
  'views.orderSettlement.search.orderStatus': 'Order status',
  'views.orderSettlement.search.orderStatusPlaceholder': 'Select order status',
  'views.orderSettlement.action.query': 'Search',
  'views.orderSettlement.action.reset': 'Reset',
  'views.orderSettlement.action.generate': 'Generate',
  'views.orderSettlement.action.paymentRecords': 'Payments',
  'views.orderSettlement.drawer.paymentTitle': 'Payments',
  'views.orderSettlement.action.delete': 'Delete',
  'views.orderSettlement.column.id': 'ID',
  'views.orderSettlement.column.userId': 'User ID',
  'views.orderSettlement.column.email': 'Email',
  'views.orderSettlement.column.nickname': 'Nickname',
  'views.orderSettlement.column.orderNo': 'Settlement No.',
  'views.orderSettlement.column.orderStatus': 'Order status',
  'views.orderSettlement.column.money': 'Amount',
  'views.orderSettlement.column.startDate': 'Start date',
  'views.orderSettlement.column.endDate': 'End date',
  'views.orderSettlement.column.createTime': 'Created at',
  'views.orderSettlement.column.operation': 'Actions',
  'views.orderSettlement.orderStatus.awaitPay': 'Awaiting payment',
  'views.orderSettlement.orderStatus.awaitAudit': 'Awaiting review',
  'views.orderSettlement.orderStatus.auditRejected': 'Rejected',
  'views.orderSettlement.orderStatus.completed': 'Completed',
  'views.orderSettlement.cell.dash': '—',
  'views.orderSettlement.pagination.total': 'Total {total}',
  'views.orderSettlement.confirm.deleteTitle': 'Delete selected records?',
  'views.orderSettlement.confirm.deleteContent': 'Selected IDs: {ids}',
  'views.orderSettlement.msg.deleteOk': 'Deleted',
  'views.orderSettlement.confirm.exportTitle': 'Export data?',
  'views.orderSettlement.confirm.exportContent': 'Exports all data matching current filters, not only selected rows.',
  'views.orderSettlement.confirm.generateTitle': 'Generate order settlements?',
  'views.orderSettlement.confirm.generateContent': 'This will run the monthly settlement job for completed monthly orders. Continue?',
  'views.orderSettlement.msg.generateOk': 'Generated successfully',
  'views.orderSettlement.export.filename': 'order_settlement_{time}.xlsx',

  'views.settlementPayment.column.id': 'ID',
  'views.settlementPayment.column.money': 'Amount',
  'views.settlementPayment.column.url': 'Payment screenshot',
  'views.settlementPayment.column.auditStatus': 'Audit status',
  'views.settlementPayment.column.auditReason': 'Audit reason',
  'views.settlementPayment.column.auditReasonEn': 'Audit reason (English)',
  'views.settlementPayment.column.sort': 'Sort',
  'views.settlementPayment.column.status': 'Status',
  'views.settlementPayment.column.createTime': 'Created at',
  'views.settlementPayment.column.operation': 'Actions',
  'views.settlementPayment.auditStatus.pending': 'Pending review',
  'views.settlementPayment.auditStatus.approved': 'Approved',
  'views.settlementPayment.auditStatus.rejected': 'Rejected',
  'views.settlementPayment.cell.dash': '—',

  'views.settlementPayment.search.settlementId': 'Settlement ID',
  'views.settlementPayment.search.settlementIdPlaceholder': 'Enter settlement ID',
  'views.settlementPayment.search.money': 'Amount',
  'views.settlementPayment.search.moneyPlaceholder': 'Enter amount',
  'views.settlementPayment.search.sort': 'Sort',
  'views.settlementPayment.search.sortPlaceholder': 'Enter sort value',
  'views.settlementPayment.action.query': 'Search',
  'views.settlementPayment.action.reset': 'Reset',
  'views.settlementPayment.action.expand': 'Expand',
  'views.settlementPayment.action.collapse': 'Collapse',
  'views.settlementPayment.action.add': 'Add',
  'views.settlementPayment.action.edit': 'Edit',
  'views.settlementPayment.action.audit': 'Review',
  'views.settlementPayment.action.delete': 'Delete',
  'views.settlementPayment.paymentType.full': 'Full payment screenshot',
  'views.settlementPayment.paymentType.first': 'First payment screenshot',
  'views.settlementPayment.paymentType.final': 'Final payment screenshot',
  'views.settlementPayment.form.titleAdd': 'Add',
  'views.settlementPayment.form.titleEdit': 'Edit',
  'views.settlementPayment.form.titleAudit': 'Review',
  'views.settlementPayment.form.settlementId': 'Settlement ID',
  'views.settlementPayment.form.settlementIdPlaceholder': 'Enter settlement ID',
  'views.settlementPayment.form.type': 'Type',
  'views.settlementPayment.form.typePlaceholder': 'Select screenshot type',
  'views.settlementPayment.form.money': 'Amount',
  'views.settlementPayment.form.moneyPlaceholder': 'Enter amount',
  'views.settlementPayment.form.url': 'Payment screenshot',
  'views.settlementPayment.form.urlPlaceholder': 'Enter screenshot URL(s), comma-separated',
  'views.settlementPayment.form.auditStatus': 'Audit status',
  'views.settlementPayment.form.auditStatusPlaceholder': 'Select audit status',
  'views.settlementPayment.form.auditReason': 'Audit reason',
  'views.settlementPayment.form.auditReasonPlaceholder': 'Enter audit reason',
  'views.settlementPayment.form.auditReasonEn': 'Audit reason (English)',
  'views.settlementPayment.form.auditReasonEnPlaceholder': 'Enter audit reason in English',
  'views.settlementPayment.form.save': 'Save',
  'views.settlementPayment.form.cancel': 'Cancel',
  'views.settlementPayment.msg.addOk': 'Created',
  'views.settlementPayment.msg.addFail': 'Create failed',
  'views.settlementPayment.msg.updateOk': 'Updated',
  'views.settlementPayment.msg.updateFail': 'Update failed',
  'views.settlementPayment.msg.detailFail': 'Failed to load details. Please try again.',
  'views.settlementPayment.pagination.total': 'Total {total}',
  'views.settlementPayment.confirm.deleteTitle': 'Delete selected records?',
  'views.settlementPayment.confirm.deleteContent': 'Selected IDs: {ids}',
  'views.settlementPayment.confirm.exportTitle': 'Export data?',
  'views.settlementPayment.confirm.exportContent': 'Exports all data matching current filters, not only selected rows.',
  'views.settlementPayment.msg.deleteOk': 'Deleted',
  'views.settlementPayment.msg.statusUpdateOk': 'Status updated',
  'views.settlementPayment.msg.statusUpdateFail': 'Status update failed',
  'views.settlementPayment.msg.sortUpdateOk': 'Sort updated',
  'views.settlementPayment.msg.sortUpdateFail': 'Sort update failed',
  'views.settlementPayment.export.filename': 'settlement_payment_{time}.xlsx',

  'views.transportation.form.name': 'Name',
  'views.transportation.form.namePlaceholder': 'Enter name',
  'views.transportation.form.nameEn': 'Name (EN)',
  'views.transportation.form.nameEnPlaceholder': 'Enter content',
  'views.transportation.form.shippingCost': 'Shipping cost (per 1kg)',
  'views.transportation.form.shippingCostPlaceholder': 'Enter shipping cost per 1kg',
  'views.transportation.form.save': 'Save',
  'views.transportation.form.cancel': 'Cancel',
  'views.transportation.title.add': 'Add',
  'views.transportation.title.edit': 'Edit',
  'views.transportation.msg.addOk': 'Created',
  'views.transportation.msg.addFail': 'Create failed',
  'views.transportation.msg.updateOk': 'Updated',
  'views.transportation.msg.updateFail': 'Update failed',

  'views.transportation.query.sort': 'Sort',
  'views.transportation.query.sortPlaceholder': 'Enter sort value',
  'views.transportation.btn.query': 'Search',
  'views.transportation.btn.reset': 'Reset',
  'views.transportation.btn.add': 'Add',
  'views.transportation.btn.edit': 'Edit',
  'views.transportation.btn.delete': 'Delete',
  'views.transportation.column.id': 'ID',
  'views.transportation.column.name': 'Name',
  'views.transportation.column.nameEn': 'Name (EN)',
  'views.transportation.column.shippingCost': 'Shipping cost (per 1kg)',
  'views.transportation.column.sort': 'Sort',
  'views.transportation.column.status': 'Status',
  'views.transportation.column.createTime': 'Created at',
  'views.transportation.column.operation': 'Actions',
  'views.transportation.pagination.total': 'Total {total}',
  'views.transportation.confirm.deleteTitle': 'Delete selected records?',
  'views.transportation.confirm.deleteContent': 'Selected IDs: {ids}',
  'views.transportation.confirm.exportTitle': 'Export data?',
  'views.transportation.confirm.exportContent': 'Exports all data matching current filters, not only selected rows.',
  'views.transportation.msg.deleteOk': 'Deleted',
  'views.transportation.msg.statusUpdateOk': 'Status updated',
  'views.transportation.msg.statusUpdateFail': 'Status update failed',
  'views.transportation.msg.sortUpdateOk': 'Sort updated',
  'views.transportation.msg.sortUpdateFail': 'Sort update failed',
  'views.transportation.export.filename': 'transportation_{time}.xlsx',

  'views.specialMultiple.query.type': 'Type',
  'views.specialMultiple.query.typePlaceholder': 'Select type',
  'views.specialMultiple.query.categoryId': 'Category ID',
  'views.specialMultiple.query.categoryIdPlaceholder': 'Enter category ID',
  'views.specialMultiple.query.expression': 'Size formula (front+back, front+back+bottom)',
  'views.specialMultiple.query.expressionPlaceholder': 'Enter size formula',
  'views.specialMultiple.query.lowerLimitExclusive': 'Lower limit',
  'views.specialMultiple.query.lowerLimitExclusivePlaceholder': 'Enter lower limit',
  'views.specialMultiple.query.upperLimitInclusive': 'Upper limit',
  'views.specialMultiple.query.upperLimitInclusivePlaceholder': 'Enter upper limit',
  'views.specialMultiple.query.mode': 'Pricing mode',
  'views.specialMultiple.query.modePlaceholder': 'Enter pricing mode',
  'views.specialMultiple.query.multiplier': 'Multiplier factor',
  'views.specialMultiple.query.multiplierPlaceholder': 'Enter multiplier factor',
  'views.specialMultiple.query.specOptionsList': 'Option values',
  'views.specialMultiple.query.specOptionsListPlaceholder': 'Select option values',
  'views.specialMultiple.query.sort': 'Sort',
  'views.specialMultiple.query.sortPlaceholder': 'Enter sort value',
  'views.specialMultiple.type.0': 'Special material',
  'views.specialMultiple.type.1': 'Special accessory',
  'views.specialMultiple.type.2': 'Special process',
  'views.specialMultiple.type.3': 'Special size',
  'views.specialMultiple.btn.query': 'Search',
  'views.specialMultiple.btn.reset': 'Reset',
  'views.specialMultiple.btn.expand': 'Expand',
  'views.specialMultiple.btn.collapse': 'Collapse',
  'views.specialMultiple.btn.add': 'Add',
  'views.specialMultiple.btn.edit': 'Edit',
  'views.specialMultiple.btn.delete': 'Delete',
  'views.specialMultiple.column.id': 'ID',
  'views.specialMultiple.column.type': 'Type',
  'views.specialMultiple.column.productType': 'Name',
  'views.specialMultiple.column.subType': 'Subtitle',
  'views.specialMultiple.column.expression': 'Size formula',
  'views.specialMultiple.column.lowerLimitExclusive': 'Lower limit',
  'views.specialMultiple.column.upperLimitInclusive': 'Upper limit',
  'views.specialMultiple.column.mode': 'Merge count',
  'views.specialMultiple.column.multiplier': 'Multiplier factor',
  'views.specialMultiple.column.specOptionsList': 'Option values',
  'views.specialMultiple.column.sort': 'Sort',
  'views.specialMultiple.column.status': 'Status',
  'views.specialMultiple.column.createTime': 'Created at',
  'views.specialMultiple.column.operation': 'Actions',
  'views.specialMultiple.pagination.total': 'Total {total}',
  'views.specialMultiple.confirm.deleteTitle': 'Delete selected records?',
  'views.specialMultiple.confirm.deleteContent': 'Selected IDs: {ids}',
  'views.specialMultiple.confirm.exportTitle': 'Export data?',
  'views.specialMultiple.confirm.exportContent': 'Exports all data matching current filters, not only selected rows.',
  'views.specialMultiple.msg.deleteOk': 'Deleted',
  'views.specialMultiple.msg.statusUpdateOk': 'Status updated',
  'views.specialMultiple.msg.statusUpdateFail': 'Status update failed',
  'views.specialMultiple.msg.sortUpdateOk': 'Sort updated',
  'views.specialMultiple.msg.sortUpdateFail': 'Sort update failed',
  'views.specialMultiple.export.filename': 'special_multiple_{time}.xlsx',
  'views.specialMultiple.title.add': 'Add',
  'views.specialMultiple.title.edit': 'Edit',
  'views.specialMultiple.form.save': 'Save',
  'views.specialMultiple.form.cancel': 'Cancel',
  'views.specialMultiple.form.name': 'Name',
  'views.specialMultiple.form.namePlaceholder': 'Enter name',
  'views.specialMultiple.form.productTypePlaceholder': 'Enter bag category',
  'views.specialMultiple.form.subTypePlaceholder': 'Enter subtitle',
  'views.specialMultiple.form.expressionBuilder.placeholder': 'Click buttons to build the formula, e.g. front+back+bottom',
  'views.specialMultiple.form.expressionToken.front': 'front (Front)',
  'views.specialMultiple.form.expressionToken.plus': '+',
  'views.specialMultiple.form.expressionToken.minus': '-',
  'views.specialMultiple.form.expressionToken.multiply': '*',
  'views.specialMultiple.form.expressionToken.divide': '/',
  'views.specialMultiple.form.expressionToken.back': 'back (Back)',
  'views.specialMultiple.form.expressionToken.bottom': 'bottom (Bottom)',
  'views.specialMultiple.form.expressionClear': 'Clear',
  'views.specialMultiple.form.expressionUndo': 'Undo',
  'views.specialMultiple.form.expressionFillExample': 'Fill example front+back+bottom',
  'views.specialMultiple.rules.typeRequired': 'Please select a type',
  'views.specialMultiple.msg.addOk': 'Created',
  'views.specialMultiple.msg.addFail': 'Create failed',
  'views.specialMultiple.msg.updateOk': 'Updated',
  'views.specialMultiple.msg.updateFail': 'Update failed',

  'views.toolMagazine.form.width': 'Width (mm)',
  'views.toolMagazine.form.widthPlaceholder': 'Enter width (mm), up to 2 decimal places',
  'views.toolMagazine.form.height': 'Height (mm)',
  'views.toolMagazine.form.heightPlaceholder': 'Enter height (mm), up to 2 decimal places',
  'views.toolMagazine.form.borderDefense': 'Side seal (mm)',
  'views.toolMagazine.form.borderDefensePlaceholder': 'Enter side seal (mm), up to 2 decimal places',
  'views.toolMagazine.form.quantity': 'Quantity (pcs)',
  'views.toolMagazine.form.quantityPlaceholder': 'Enter quantity (integer)',
  'views.toolMagazine.form.specOption': 'Spec option',
  'views.toolMagazine.form.specOptionPlaceholder': 'Select or search spec option',
  'views.toolMagazine.query.namePlaceholder': 'Enter name',
  'views.toolMagazine.query.sortPlaceholder': 'Enter sort',
  'views.toolMagazine.column.id': 'ID',
  'views.toolMagazine.column.specOptionName': 'Spec option',
  'views.toolMagazine.column.name': 'Name',
  'views.toolMagazine.column.nameEn': 'Name (EN)',
  'views.toolMagazine.column.width': 'Width (mm)',
  'views.toolMagazine.column.height': 'Height (mm)',
  'views.toolMagazine.column.borderDefense': 'Side seal (mm)',
  'views.toolMagazine.column.quantity': 'Quantity (pcs)',
  'views.toolMagazine.column.productionTime': 'Production time',
  'views.toolMagazine.column.sort': 'Sort',
  'views.toolMagazine.column.status': 'Status',
  'views.toolMagazine.column.createTime': 'Created at',
  'views.toolMagazine.column.operation': 'Actions',
  'views.toolMagazine.btn.query': 'Search',
  'views.toolMagazine.btn.reset': 'Reset',
  'views.toolMagazine.btn.add': 'Add',
  'views.toolMagazine.btn.edit': 'Edit',
  'views.toolMagazine.btn.delete': 'Delete',
  'views.toolMagazine.btn.import': 'Import',
  'views.toolMagazine.import.title': 'Import tool magazine',
  'views.toolMagazine.import.uploading': 'Uploading...',
  'views.toolMagazine.import.dragHint': 'Drag file here to upload',
  'views.toolMagazine.import.clickHint': 'Supports .xlsx / .xls, or click to select',
  'views.toolMagazine.import.downloadTemplate': 'Download import template',
  'views.toolMagazine.import.fileRequired': 'Please select a file first',
  'views.toolMagazine.import.ok': 'Import succeeded',
  'views.toolMagazine.import.fail': 'Import failed',
  'views.toolMagazine.pagination.total': 'Total {total}',
  'views.toolMagazine.confirm.deleteTitle': 'Delete selected records?',
  'views.toolMagazine.confirm.deleteContent': 'Selected IDs: {ids}',
  'views.toolMagazine.msg.deleteOk': 'Deleted',
  'views.toolMagazine.msg.statusOk': 'Status updated',
  'views.toolMagazine.msg.statusFail': 'Status update failed',
  'views.toolMagazine.msg.sortOk': 'Sort updated',
  'views.toolMagazine.msg.sortFail': 'Sort update failed',

  'views.systemUser.query.userName': 'Username',
  'views.systemUser.query.userNamePlaceholder': 'Enter username',
  'views.systemUser.query.phoneNumber': 'Phone',
  'views.systemUser.query.phoneNumberPlaceholder': 'Enter phone number',
  'views.systemUser.query.status': 'Status',
  'views.systemUser.query.statusPlaceholder': 'Select status',
  'views.systemUser.query.createTime': 'Created at',
  'views.systemUser.btn.query': 'Search',
  'views.systemUser.btn.reset': 'Reset',
  'views.systemUser.btn.add': 'Add',
  'views.systemUser.btn.edit': 'Edit',
  'views.systemUser.btn.delete': 'Delete',
  'views.systemUser.btn.import': 'Import',
  'views.systemUser.btn.more': 'More',
  'views.systemUser.action.resetPassword': 'Reset password',
  'views.systemUser.action.assignRole': 'Assign roles',
  'views.systemUser.column.id': 'User ID',
  'views.systemUser.column.userName': 'Username',
  'views.systemUser.column.phoneNumber': 'Phone',
  'views.systemUser.column.nickName': 'Nickname',
  'views.systemUser.column.dept': 'Department',
  'views.systemUser.column.status': 'Status',
  'views.systemUser.column.createTime': 'Created at',
  'views.systemUser.column.operation': 'Actions',
  'views.systemUser.pagination.total': 'Total {total}',
  'views.systemUser.status.enable': 'Enable',
  'views.systemUser.status.disable': 'Disable',
  'views.systemUser.msg.statusSuccess': '{action} succeeded',
  'views.systemUser.msg.statusFail': '{action} failed: {message}',
  'views.systemUser.msg.statusException': '{action} error',
  'views.systemUser.confirm.deleteTitle': 'Delete selected records?',
  'views.systemUser.confirm.deleteContent': 'Selected IDs: {ids}',
  'views.systemUser.msg.deleteSuccess': 'Deleted',
  'views.systemUser.confirm.exportTitle': 'Export data?',
  'views.systemUser.confirm.exportContent': 'This exports all data under current filters, not only selected rows.',
  'views.systemUser.deptTree.searchPlaceholder': 'Search departments',
  'views.systemUser.form.nickName': 'Nickname',
  'views.systemUser.form.dept': 'Department',
  'views.systemUser.form.phoneNumber': 'Phone',
  'views.systemUser.form.email': 'Email',
  'views.systemUser.form.userName': 'Username',
  'views.systemUser.form.password': 'Password',
  'views.systemUser.form.sex': 'Gender',
  'views.systemUser.form.status': 'Status',
  'views.systemUser.form.post': 'Post',
  'views.systemUser.form.role': 'Role',
  'views.systemUser.form.remark': 'Remark',
  'views.systemUser.form.placeholderInput': 'Enter',
  'views.systemUser.form.placeholderSelect': 'Select',
  'views.systemUser.form.save': 'Save',
  'views.systemUser.form.cancel': 'Cancel',
  'views.systemUser.form.titleAdd': 'Add user',
  'views.systemUser.form.titleEdit': 'Edit user',
  'views.systemUser.form.rules.userNameRequired': 'Username is required',
  'views.systemUser.form.rules.nickNameRequired': 'Nickname is required',
  'views.systemUser.form.rules.deptRequired': 'Department is required',
  'views.systemUser.form.rules.passwordRequired': 'Password is required',
  'views.systemUser.form.rules.passwordLength': 'Password must be 5-20 characters',
  'views.systemUser.form.rules.emailRequired': 'Email is required',
  'views.systemUser.form.rules.emailInvalid': 'Enter a valid email address',
  'views.systemUser.form.rules.phoneRequired': 'Phone number is required',
  'views.systemUser.form.rules.phoneInvalid': 'Enter a valid phone number',
  'views.systemUser.msg.addSuccess': 'Created',
  'views.systemUser.msg.updateSuccess': 'Updated',
  'views.systemUser.resetPwd.title': 'Reset password',
  'views.systemUser.resetPwd.userName': 'Username',
  'views.systemUser.resetPwd.newPassword': 'New password',
  'views.systemUser.resetPwd.newPasswordPlaceholder': 'Enter new password',
  'views.systemUser.resetPwd.confirmPassword': 'Confirm password',
  'views.systemUser.resetPwd.confirmPasswordPlaceholder': 'Confirm password',
  'views.systemUser.resetPwd.err.newPwdRequired': 'Enter new password',
  'views.systemUser.resetPwd.err.newPwdPattern': 'Enter 5-20 characters using letters, numbers, or symbols (no spaces); at least two types required',
  'views.systemUser.resetPwd.err.confirmRequired': 'Confirm new password',
  'views.systemUser.resetPwd.err.confirmMismatch': 'Passwords do not match',
  'views.systemUser.resetPwd.msg.success': 'Password reset',
  'views.systemUser.authRole.title': 'Assign roles',
  'views.systemUser.authRole.column.id': 'Role ID',
  'views.systemUser.authRole.column.roleName': 'Role name',
  'views.systemUser.authRole.column.roleKey': 'Permission key',
  'views.systemUser.authRole.column.createTime': 'Created at',
  'views.systemUser.import.title': 'Import users',
  'views.systemUser.import.uploading': 'Uploading...',
  'views.systemUser.import.dragHint': 'Drag file here to upload',
  'views.systemUser.import.clickHint': 'Single file upload, or click to select',
  'views.systemUser.import.updateSupport': 'Update existing user records if found',
  'views.systemUser.import.downloadTemplate': 'Download template',

  'views.systemRole.query.roleName': 'Role name',
  'views.systemRole.query.roleNamePlaceholder': 'Enter role name',
  'views.systemRole.query.roleKey': 'Permission key',
  'views.systemRole.query.roleKeyPlaceholder': 'Enter permission key',
  'views.systemRole.query.status': 'Status',
  'views.systemRole.query.statusPlaceholder': 'Select status',
  'views.systemRole.query.createTime': 'Created at',
  'views.systemRole.btn.query': 'Search',
  'views.systemRole.btn.reset': 'Reset',
  'views.systemRole.btn.add': 'Add',
  'views.systemRole.btn.edit': 'Edit',
  'views.systemRole.btn.delete': 'Delete',
  'views.systemRole.btn.more': 'More',
  'views.systemRole.action.assignUser': 'Assign users',
  'views.systemRole.column.id': 'Role ID',
  'views.systemRole.column.roleName': 'Role name',
  'views.systemRole.column.roleKey': 'Permission key',
  'views.systemRole.column.roleSort': 'Sort',
  'views.systemRole.column.status': 'Status',
  'views.systemRole.column.createTime': 'Created at',
  'views.systemRole.column.operation': 'Actions',
  'views.systemRole.pagination.total': 'Total {total}',
  'views.systemRole.status.enable': 'Enable',
  'views.systemRole.status.disable': 'Disable',
  'views.systemRole.msg.statusSuccess': '{action} succeeded',
  'views.systemRole.msg.statusFail': '{action} failed: {message}',
  'views.systemRole.msg.statusException': '{action} error',
  'views.systemRole.confirm.deleteTitle': 'Delete selected records?',
  'views.systemRole.confirm.deleteContent': 'Selected IDs: {ids}',
  'views.systemRole.msg.deleteSuccess': 'Deleted',
  'views.systemRole.confirm.exportTitle': 'Export data?',
  'views.systemRole.confirm.exportContent': 'This exports all data under current filters, not only selected rows.',
  'views.systemRole.dict.status.0': 'Disabled',
  'views.systemRole.dict.status.1': 'Enabled',
  'views.systemRole.form.roleName': 'Role name',
  'views.systemRole.form.roleKey': 'Permission key',
  'views.systemRole.form.roleKeyTooltip': 'Permission key defined in controller, e.g. @PreAuthorize(`@ss.hasRole(\'admin\')`)',
  'views.systemRole.form.roleSort': 'Sort order',
  'views.systemRole.form.status': 'Status',
  'views.systemRole.form.menuPermission': 'Menu permissions',
  'views.systemRole.form.expandCollapse': 'Expand/Collapse',
  'views.systemRole.form.selectAll': 'Select all/None',
  'views.systemRole.form.parentChildLink': 'Parent-child link',
  'views.systemRole.form.parentChildTooltip': 'Switch mode only when no items are checked. Click "Select none" first, then switch.',
  'views.systemRole.form.remark': 'Remark',
  'views.systemRole.form.placeholderInput': 'Enter',
  'views.systemRole.form.save': 'Save',
  'views.systemRole.form.cancel': 'Cancel',
  'views.systemRole.form.titleAdd': 'Add role',
  'views.systemRole.form.titleEdit': 'Edit role',
  'views.systemRole.form.adminAlert': 'Super admin role cannot be modified',
  'views.systemRole.form.rules.roleNameRequired': 'Role name is required',
  'views.systemRole.form.rules.roleKeyRequired': 'Permission key is required',
  'views.systemRole.form.rules.roleSortRequired': 'Sort order is required',
  'views.systemRole.msg.addSuccess': 'Created',
  'views.systemRole.msg.updateSuccess': 'Updated',
  'views.systemRole.msg.updateFail': 'Update failed: {message}',

  'views.systemRole.msg.updateFail': 'Update failed: {message}',

  'views.systemMenu.query.menuName': 'Menu name',
  'views.systemMenu.query.menuNamePlaceholder': 'Enter menu name',
  'views.systemMenu.query.status': 'Status',
  'views.systemMenu.query.statusPlaceholder': 'Select status',
  'views.systemMenu.btn.query': 'Search',
  'views.systemMenu.btn.reset': 'Reset',
  'views.systemMenu.btn.add': 'Add',
  'views.systemMenu.btn.edit': 'Edit',
  'views.systemMenu.btn.delete': 'Delete',
  'views.systemMenu.column.menuName': 'Menu name',
  'views.systemMenu.column.icon': 'Icon',
  'views.systemMenu.column.orderNum': 'Sort',
  'views.systemMenu.column.perms': 'Permission key',
  'views.systemMenu.column.component': 'Component path',
  'views.systemMenu.column.status': 'Status',
  'views.systemMenu.column.createTime': 'Created at',
  'views.systemMenu.column.operation': 'Actions',
  'views.systemMenu.confirm.deleteTitle': 'Delete selected records?',
  'views.systemMenu.confirm.deleteContent': 'Selected IDs: {ids}',
  'views.systemMenu.msg.deleteSuccess': 'Deleted',
  'views.systemMenu.rootDir': 'Root',
  'views.systemMenu.dict.status.0': 'Disabled',
  'views.systemMenu.dict.status.1': 'Enabled',
  'views.systemMenu.dict.visible.0': 'Hidden',
  'views.systemMenu.dict.visible.1': 'Visible',
  'views.systemMenu.dict.yesNo.0': 'No',
  'views.systemMenu.dict.yesNo.1': 'Yes',
  'views.systemMenu.form.parentMenu': 'Parent menu',
  'views.systemMenu.form.menuType': 'Menu type',
  'views.systemMenu.form.menuType.dir': 'Directory',
  'views.systemMenu.form.menuType.menu': 'Menu',
  'views.systemMenu.form.menuType.button': 'Button',
  'views.systemMenu.form.icon': 'Icon',
  'views.systemMenu.form.selectIcon': 'Select icon',
  'views.systemMenu.form.collapseIcon': 'Collapse',
  'views.systemMenu.form.menuName': 'Menu name',
  'views.systemMenu.form.orderNum': 'Sort order',
  'views.systemMenu.form.isFrame': 'External link',
  'views.systemMenu.form.isFrameTooltip': 'If external link, route path must start with `http(s)://`',
  'views.systemMenu.form.path': 'Route path',
  'views.systemMenu.form.pathTooltip': 'Route path, e.g. `user`. For external URLs use `http(s)://` prefix.',
  'views.systemMenu.form.component': 'Component path',
  'views.systemMenu.form.componentTooltip': 'Component path, e.g. `system/user/index` under `views` by default.',
  'views.systemMenu.form.perms': 'Permission key',
  'views.systemMenu.form.permsTooltip': 'Permission key in controller, e.g. @PreAuthorize(`@ss.hasPermi(\'system:user:list\')`)',
  'views.systemMenu.form.visible': 'Visible',
  'views.systemMenu.form.visibleTooltip': 'Hidden menus stay accessible but do not appear in the sidebar.',
  'views.systemMenu.form.status': 'Status',
  'views.systemMenu.form.statusTooltip': 'Disabled menus are hidden from sidebar and cannot be accessed.',
  'views.systemMenu.form.isCache': 'Keep alive',
  'views.systemMenu.form.isCacheTooltip': 'When enabled, cached by keep-alive; component name must match route. Works with multi-tab only.',
  'views.systemMenu.form.placeholderInput': 'Enter',
  'views.systemMenu.form.placeholderSelect': 'Select',
  'views.systemMenu.form.save': 'Save',
  'views.systemMenu.form.cancel': 'Cancel',
  'views.systemMenu.form.titleAdd': 'Add menu',
  'views.systemMenu.form.titleEdit': 'Edit menu',
  'views.systemMenu.form.rules.menuNameRequired': 'Menu name is required',
  'views.systemMenu.form.rules.orderNumRequired': 'Sort order is required',
  'views.systemMenu.form.rules.pathRequired': 'Route path is required',
  'views.systemMenu.form.rules.componentRequired': 'Component path is required',
  'views.systemMenu.msg.addSuccess': 'Created',
  'views.systemMenu.msg.updateSuccess': 'Updated',

  'views.systemDept.query.deptName': 'Department name',
  'views.systemDept.query.deptNamePlaceholder': 'Enter department name',
  'views.systemDept.query.status': 'Status',
  'views.systemDept.query.statusPlaceholder': 'Select status',
  'views.systemDept.btn.query': 'Search',
  'views.systemDept.btn.reset': 'Reset',
  'views.systemDept.btn.add': 'Add',
  'views.systemDept.btn.edit': 'Edit',
  'views.systemDept.btn.delete': 'Delete',
  'views.systemDept.column.id': 'Department ID',
  'views.systemDept.column.deptName': 'Department name',
  'views.systemDept.column.orderNum': 'Sort',
  'views.systemDept.column.status': 'Status',
  'views.systemDept.column.createTime': 'Created at',
  'views.systemDept.column.operation': 'Actions',
  'views.systemDept.dict.status.0': 'Disabled',
  'views.systemDept.dict.status.1': 'Enabled',
  'views.systemDept.status.enable': 'Enable',
  'views.systemDept.status.disable': 'Disable',
  'views.systemDept.msg.statusSuccess': '{action} succeeded',
  'views.systemDept.msg.statusFail': '{action} failed: {message}',
  'views.systemDept.msg.statusException': '{action} error',
  'views.systemDept.confirm.deleteTitle': 'Delete selected records?',
  'views.systemDept.confirm.deleteContent': 'Selected IDs: {ids}',
  'views.systemDept.msg.deleteSuccess': 'Deleted',
  'views.systemDept.form.parentDept': 'Parent department',
  'views.systemDept.form.deptName': 'Department name',
  'views.systemDept.form.orderNum': 'Sort order',
  'views.systemDept.form.leader': 'Leader',
  'views.systemDept.form.phone': 'Phone',
  'views.systemDept.form.email': 'Email',
  'views.systemDept.form.status': 'Status',
  'views.systemDept.form.placeholderInput': 'Enter',
  'views.systemDept.form.placeholderSelect': 'Select',
  'views.systemDept.form.save': 'Save',
  'views.systemDept.form.cancel': 'Cancel',
  'views.systemDept.form.titleAdd': 'Add department',
  'views.systemDept.form.titleEdit': 'Edit department',
  'views.systemDept.form.rules.parentDeptRequired': 'Parent department is required',
  'views.systemDept.form.rules.deptNameRequired': 'Department name is required',
  'views.systemDept.form.rules.orderNumRequired': 'Sort order is required',
  'views.systemDept.form.rules.emailInvalid': 'Enter a valid email address',
  'views.systemDept.form.rules.phoneInvalid': 'Enter a valid phone number',
  'views.systemDept.msg.addSuccess': 'Created',
  'views.systemDept.msg.updateSuccess': 'Updated',

  'views.systemPost.query.postCode': 'Post code',
  'views.systemPost.query.postCodePlaceholder': 'Enter post code',
  'views.systemPost.query.postName': 'Post name',
  'views.systemPost.query.postNamePlaceholder': 'Enter post name',
  'views.systemPost.query.status': 'Status',
  'views.systemPost.query.statusPlaceholder': 'Select status',
  'views.systemPost.btn.query': 'Search',
  'views.systemPost.btn.reset': 'Reset',
  'views.systemPost.btn.add': 'Add',
  'views.systemPost.btn.edit': 'Edit',
  'views.systemPost.btn.delete': 'Delete',
  'views.systemPost.column.id': 'Post ID',
  'views.systemPost.column.postCode': 'Post code',
  'views.systemPost.column.postName': 'Post name',
  'views.systemPost.column.postSort': 'Sort',
  'views.systemPost.column.status': 'Status',
  'views.systemPost.column.createTime': 'Created at',
  'views.systemPost.column.operation': 'Actions',
  'views.systemPost.pagination.total': 'Total {total}',
  'views.systemPost.dict.status.0': 'Disabled',
  'views.systemPost.dict.status.1': 'Enabled',
  'views.systemPost.status.enable': 'Enable',
  'views.systemPost.status.disable': 'Disable',
  'views.systemPost.msg.statusSuccess': '{action} succeeded',
  'views.systemPost.msg.statusFail': '{action} failed: {message}',
  'views.systemPost.msg.statusException': '{action} error',
  'views.systemPost.confirm.deleteTitle': 'Delete selected records?',
  'views.systemPost.confirm.deleteContent': 'Selected IDs: {ids}',
  'views.systemPost.msg.deleteSuccess': 'Deleted',
  'views.systemPost.confirm.exportTitle': 'Export data?',
  'views.systemPost.confirm.exportContent': 'This exports all data under current filters, not only selected rows.',
  'views.systemPost.form.postName': 'Post name',
  'views.systemPost.form.postCode': 'Post code',
  'views.systemPost.form.postSort': 'Sort order',
  'views.systemPost.form.status': 'Status',
  'views.systemPost.form.remark': 'Remark',
  'views.systemPost.form.placeholderInput': 'Enter',
  'views.systemPost.form.save': 'Save',
  'views.systemPost.form.cancel': 'Cancel',
  'views.systemPost.form.titleAdd': 'Add post',
  'views.systemPost.form.titleEdit': 'Edit post',
  'views.systemPost.form.rules.postNameRequired': 'Post name is required',
  'views.systemPost.form.rules.postCodeRequired': 'Post code is required',
  'views.systemPost.form.rules.postSortRequired': 'Sort order is required',
  'views.systemPost.msg.addSuccess': 'Created',
  'views.systemPost.msg.updateSuccess': 'Updated',

  'views.systemUser.dict.sex.0': 'Secret',
  'views.systemUser.dict.sex.1': 'Male',
  'views.systemUser.dict.sex.2': 'Female',
  'views.systemUser.dict.status.0': 'Disabled',
  'views.systemUser.dict.status.1': 'Normal',

  'views.home.welcomeTitle': 'Welcome to Admin Console',
  'views.home.welcomeSubtitle': 'Efficient, secure, and easy-to-use management platform',
  'views.home.systemRunning': 'System running normally',
  'views.home.versionTag': 'Version {version}',
  'views.home.remindersTitle': 'Reminders',
  'views.home.systemStatusTitle': 'System status',
  'views.home.runStatusLabel': 'Run status',
  'views.home.lastUpdate': 'Last updated',
  'views.home.supportTitle': 'Technical support',
  'views.home.phone': 'Phone',
  'views.home.email': 'Email',
  'views.home.serviceHours': 'Service hours',
  'views.home.weekdays': 'Monday to Friday',
  'views.home.serviceTimeRange': '9:30 - 18:00',
  'views.home.versionInfoTitle': 'Version info',
  'views.home.stableVersion': 'Current stable release',
  'views.home.footer': 'Admin Console — management made simple',
  'views.home.reminder.securityTitle': 'Security reminder',
  'views.home.reminder.securityContent': 'Change your password regularly to keep your account secure.',
  'views.home.reminder.tipTitle': 'Tips',
  'views.home.reminder.tipContent': 'Use the latest version of Chrome for the best experience.',

  'utils.uploadOss.ossConfigFailed': 'Failed to get OSS configuration',
  'utils.uploadOss.uploadFailedRetry': 'Upload failed, please try again',
  'utils.uploadOss.uploadFailed': 'Upload failed: {message}',
  'utils.uploadOss.getConfigFailed': 'Failed to get upload configuration: {message}',
  'utils.uploadOss.unknownError': 'Unknown error'
}
